// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AbandonIngestionTaskData, AbandonIngestionTaskErrors, AbandonIngestionTaskResponses, AbandonSourceTaskData, AbandonSourceTaskErrors, AbandonSourceTaskResponses, AddSdgRevenuePipelineApprovalData, AddSdgRevenuePipelineApprovalErrors, AddSdgRevenuePipelineApprovalResponses, AssignIngestionTaskData, AssignIngestionTaskErrors, AssignIngestionTaskResponses, BulkAcceptFactsFromQueryData, BulkAcceptFactsFromQueryErrors, BulkAcceptFactsFromQueryResponses, BulkAcceptFromCsvData, BulkAcceptFromCsvErrors, BulkAcceptFromCsvResponses, BulkDeleteFactsData, BulkDeleteFactsErrors, BulkDeleteFactsResponses, CalculateRevenueDeltasData, CalculateRevenueDeltasErrors, CalculateRevenueDeltasResponses, ConvertUnitData, ConvertUnitErrors, ConvertUnitResponses, CopyPortfolioData, CopyPortfolioErrors, CopyPortfolioResponses, CopyReferencePortfolioData, CopyReferencePortfolioErrors, CopyReferencePortfolioResponses, CreateEntitiesData, CreateEntitiesErrors, CreateEntitiesResponses, CreateEntityData, CreateEntityErrors, CreateEntityResponses, CreateFactData, CreateFactErrors, CreateFactResponses, CreateFactsForThemeData, CreateFactsForThemeErrors, CreateFactsForThemeResponses, CreateIngestionTasksData, CreateIngestionTasksErrors, CreateIngestionTasksResponses, CreateKeywordData, CreateKeywordErrors, CreateKeywordResponses, CreateKpiData, CreateKpiErrors, CreateKpiResponses, CreateMetricData, CreateMetricErrors, CreateMetricResponses, CreateNewFactsData, CreateNewFactsErrors, CreateNewFactsResponses, CreateSegmentData, CreateSegmentErrors, CreateSegmentResponses, CreateSourceData, CreateSourceErrors, CreateSourceResponses, CreateSourceTasksData, CreateSourceTasksErrors, CreateSourceTasksResponses, CreateUnitData, CreateUnitErrors, CreateUnitResponses, CreateWatchlistData, CreateWatchlistErrors, CreateWatchlistResponses, DeleteEntityData, DeleteEntityErrors, DeleteEntityResponses, DeleteFactData, DeleteFactErrors, DeleteFactResponses, DeleteHoldingsFromWatchlistData, DeleteHoldingsFromWatchlistErrors, DeleteHoldingsFromWatchlistResponses, DeleteKeywordData, DeleteKeywordErrors, DeleteKeywordResponses, DeleteKpiData, DeleteKpiErrors, DeleteKpiResponses, DeleteMetricData, DeleteMetricErrors, DeleteMetricResponses, DeletePortfolioData, DeletePortfolioErrors, DeletePortfolioResponses, DeleteSegmentData, DeleteSegmentErrors, DeleteSegmentResponses, DeleteSnapshotData, DeleteSnapshotErrors, DeleteSnapshotResponses, DeleteSourceData, DeleteSourceErrors, DeleteSourceResponses, DeleteUnitData, DeleteUnitErrors, DeleteUnitResponses, DeliberateErrorKaboomGetData, DeliberateErrorKaboomGetResponses, DissociateSourceFromEntityData, DissociateSourceFromEntityErrors, DissociateSourceFromEntityResponses, EmbedSourcesData, EmbedSourcesErrors, EmbedSourcesResponses, ExportAllSdiFilesXlsxData, ExportAllSdiFilesXlsxErrors, ExportAllSdiFilesXlsxResponses, ExportCompareDataData, ExportCompareDataErrors, ExportCompareDataResponses, ExportDataDictionaryData, ExportDataDictionaryErrors, ExportDataDictionaryResponses, ExportEntityActivitiesXlsxData, ExportEntityActivitiesXlsxErrors, ExportEntityActivitiesXlsxResponses, ExportEntityDashboardXlsxData, ExportEntityDashboardXlsxErrors, ExportEntityDashboardXlsxResponses, ExportEntityData, ExportEntityErrors, ExportEntityResponses, ExportEntitySdiRevenueXlsxData, ExportEntitySdiRevenueXlsxErrors, ExportEntitySdiRevenueXlsxResponses, ExportHoldingsData, ExportHoldingsErrors, ExportHoldingsResponses, ExportPortfolioDashboardData, ExportPortfolioDashboardErrors, ExportPortfolioDashboardResponses, ExportPortfolioData, ExportPortfolioDataData, ExportPortfolioDataErrors, ExportPortfolioDataResponses, ExportPortfolioErrors, ExportPortfolioPaiData, ExportPortfolioPaiErrors, ExportPortfolioPaiResponses, ExportPortfolioResponses, ExportPortfolioSdgData, ExportPortfolioSdgErrors, ExportPortfolioSdgResponses, ExportPortfolioSdgRevenueData, ExportPortfolioSdgRevenueErrors, ExportPortfolioSdgRevenueResponses, ExportSdgRevenueDataChangesData, ExportSdgRevenueDataChangesErrors, ExportSdgRevenueDataChangesResponses, GetAcceptedFactData, GetAcceptedFactErrors, GetAcceptedFactResponses, GetAcceptedFactValuesData, GetAcceptedFactValuesErrors, GetAcceptedFactValuesResponses, GetAnalystStatsData, GetAnalystStatsErrors, GetAnalystStatsResponses, GetCandidateFactData, GetCandidateFactErrors, GetCandidateFactResponses, GetCoverageStatsData, GetCoverageStatsErrors, GetCoverageStatsResponses, GetDataDictionaryData, GetDataDictionaryErrors, GetDataDictionaryResponses, GetDisclosureDataData, GetDisclosureDataErrors, GetDisclosureDataResponses, GetEntityActivitiesSdgRevenueAlignmentByTaxonData, GetEntityActivitiesSdgRevenueAlignmentByTaxonErrors, GetEntityActivitiesSdgRevenueAlignmentByTaxonResponses, GetEntityActivitiesSdgRevenueAlignmentData, GetEntityActivitiesSdgRevenueAlignmentErrors, GetEntityActivitiesSdgRevenueAlignmentResponses, GetEntityBreakdownByFundsData, GetEntityBreakdownByFundsErrors, GetEntityBreakdownByFundsResponses, GetEntityDashboardDataData, GetEntityDashboardDataErrors, GetEntityDashboardDataResponses, GetEntityData, GetEntityErrors, GetEntityEstimationsSummaryData, GetEntityEstimationsSummaryErrors, GetEntityEstimationsSummaryResponses, GetEntityPortfoliosData, GetEntityPortfoliosErrors, GetEntityPortfoliosResponses, GetEntityResponses, GetEntitySdiActivityExplanationData, GetEntitySdiActivityExplanationErrors, GetEntitySdiActivityExplanationResponses, GetEntitySdiRationaleData, GetEntitySdiRationaleErrors, GetEntitySdiRationaleResponses, GetEntitySdiRevenueContributionData, GetEntitySdiRevenueContributionErrors, GetEntitySdiRevenueContributionResponses, GetEnumData, GetEnumDetailsData, GetEnumDetailsErrors, GetEnumDetailsResponses, GetEnumErrors, GetEnumResponses, GetEstimatedDataData, GetEstimatedDataErrors, GetEstimatedDataResponses, GetEuSfdrFactData, GetEuSfdrFactErrors, GetEuSfdrFactResponses, GetFactChangesData, GetFactChangesErrors, GetFactChangesResponses, GetFactData, GetFactErrors, GetFactResponses, GetGoalQuestionsData, GetGoalQuestionsResponses, GetInactiveEntityData, GetInactiveEntityErrors, GetInactiveEntityResponses, GetInconsistenciesSummaryData, GetInconsistenciesSummaryErrors, GetInconsistenciesSummaryResponses, GetIngestionBatchData, GetIngestionBatchErrors, GetIngestionBatchResponses, GetIngestionTaskData, GetIngestionTaskErrors, GetIngestionTaskResponses, GetKeywordData, GetKeywordErrors, GetKeywordResponses, GetKpiData, GetKpiErrors, GetKpiResponses, GetKpiResultData, GetKpiResultErrors, GetKpiResultResponses, GetLatestDataData, GetLatestDataErrors, GetLatestDataResponses, GetMetricData, GetMetricErrors, GetMetricPagePredictionsData, GetMetricPagePredictionsErrors, GetMetricPagePredictionsResponses, GetMetricResponses, GetNextTaskAcrossStepsData, GetNextTaskAcrossStepsResponses, GetNextTaskData, GetNextTaskErrors, GetNextTaskResponses, GetOverallStatsData, GetOverallStatsErrors, GetOverallStatsResponses, GetPagePredictionsData, GetPagePredictionsErrors, GetPagePredictionsResponses, GetPortfolioDashboardDataData, GetPortfolioDashboardDataErrors, GetPortfolioDashboardDataResponses, GetPortfolioLabelsUnweightedData, GetPortfolioLabelsUnweightedErrors, GetPortfolioLabelsUnweightedResponses, GetPortfolioLabelsWeightedData, GetPortfolioLabelsWeightedErrors, GetPortfolioLabelsWeightedResponses, GetPortfolioSdgOutcomesSummaryData, GetPortfolioSdgOutcomesSummaryErrors, GetPortfolioSdgOutcomesSummaryResponses, GetPortfolioSdgRevenueSummaryUnweightedData, GetPortfolioSdgRevenueSummaryUnweightedErrors, GetPortfolioSdgRevenueSummaryUnweightedResponses, GetPortfolioSdgRevenueSummaryWeightedData, GetPortfolioSdgRevenueSummaryWeightedErrors, GetPortfolioSdgRevenueSummaryWeightedResponses, GetPortfolioSdiRevenueSummaryUnweightedData, GetPortfolioSdiRevenueSummaryUnweightedErrors, GetPortfolioSdiRevenueSummaryUnweightedResponses, GetPortfolioSdiRevenueSummaryWeightedData, GetPortfolioSdiRevenueSummaryWeightedErrors, GetPortfolioSdiRevenueSummaryWeightedResponses, GetPortfolioWithHoldingsData, GetPortfolioWithHoldingsErrors, GetPortfolioWithHoldingsResponses, GetQuestionCoverageDataData, GetQuestionCoverageDataErrors, GetQuestionCoverageDataResponses, GetQuestionData, GetQuestionErrors, GetQuestionNamesData, GetQuestionNamesErrors, GetQuestionNamesResponses, GetQuestionResponses, GetReportingStandardsData, GetReportingStandardsErrors, GetReportingStandardsResponses, GetReportTypesConfidenceData, GetReportTypesConfidenceErrors, GetReportTypesConfidenceResponses, GetResultStatusData, GetResultStatusErrors, GetResultStatusResponses, GetSdiDataBundleDownloadUrlData, GetSdiDataBundleDownloadUrlErrors, GetSdiDataBundleDownloadUrlResponses, GetSdiSubscriberPackDownloadUrlData, GetSdiSubscriberPackDownloadUrlErrors, GetSdiSubscriberPackDownloadUrlResponses, GetSegmentData, GetSegmentErrors, GetSegmentResponses, GetSnapshotWithHoldingsData, GetSnapshotWithHoldingsErrors, GetSnapshotWithHoldingsResponses, GetSnapshotWithNumHoldingsData, GetSnapshotWithNumHoldingsErrors, GetSnapshotWithNumHoldingsResponses, GetSourceBatchData, GetSourceBatchErrors, GetSourceBatchResponses, GetSourceData, GetSourceErrors, GetSourceResponses, GetSourceTaskData, GetSourceTaskErrors, GetSourceTaskResponses, GetTemporaryTableDatesData, GetTemporaryTableDatesResponses, GetThemePagePredictionsData, GetThemePagePredictionsErrors, GetThemePagePredictionsResponses, GetTimeseriesFactsData, GetTimeseriesFactsErrors, GetTimeseriesFactsResponses, GetUnitData, GetUnitErrors, GetUnitResponses, GetValidationPipelineStatusData, GetValidationPipelineStatusResponses, GetWriteUpData, GetWriteUpErrors, GetWriteUpResponses, GlobalSearchData, GlobalSearchErrors, GlobalSearchResponses, HealthCheckHealthyGetData, HealthCheckHealthyGetResponses, IdentifyEntitiesData, IdentifyEntitiesErrors, IdentifyEntitiesResponses, ListAcceptedFactChangesData, ListAcceptedFactChangesErrors, ListAcceptedFactChangesResponses, ListAcceptedFactsData, ListAcceptedFactsErrors, ListAcceptedFactsResponses, ListEntitiesData, ListEntitiesErrors, ListEntitiesResponses, ListEnumsData, ListEnumsResponses, ListEstimatedDataData, ListEstimatedDataErrors, ListEstimatedDataResponses, ListEuSfdrFactsData, ListEuSfdrFactsErrors, ListEuSfdrFactsResponses, ListEuSfdrSegmentsData, ListEuSfdrSegmentsErrors, ListEuSfdrSegmentsResponses, ListExportsData, ListExportsResponses, ListFactsData, ListFactsErrors, ListFactsResponses, ListFeedbackData, ListFeedbackErrors, ListFeedbackResponses, ListHoldingsData, ListHoldingsErrors, ListHoldingsResponses, ListInactiveEntitiesData, ListInactiveEntitiesErrors, ListInactiveEntitiesResponses, ListIngestionBatchesData, ListIngestionBatchesErrors, ListIngestionBatchesResponses, ListKeywordsData, ListKeywordsErrors, ListKeywordsResponses, ListKpiResultsData, ListKpiResultsErrors, ListKpiResultsResponses, ListKpisData, ListKpisErrors, ListKpisResponses, ListMetricsData, ListMetricsErrors, ListMetricsResponses, ListPortfolioDataData, ListPortfolioDataErrors, ListPortfolioDataResponses, ListPortfolioHoldingsData, ListPortfolioHoldingsErrors, ListPortfolioHoldingsResponses, ListPortfoliosData, ListPortfoliosErrors, ListPortfolioSnapshotsData, ListPortfolioSnapshotsErrors, ListPortfolioSnapshotsResponses, ListPortfolioSourcesData, ListPortfolioSourcesErrors, ListPortfolioSourcesResponses, ListPortfoliosResponses, ListPortfolioWithFundsHoldingsByCompanyData, ListPortfolioWithFundsHoldingsByCompanyErrors, ListPortfolioWithFundsHoldingsByCompanyResponses, ListQuestionEntitiesDataData, ListQuestionEntitiesDataErrors, ListQuestionEntitiesDataResponses, ListRecentErrorsData, ListRecentErrorsErrors, ListRecentErrorsForUserData, ListRecentErrorsForUserErrors, ListRecentErrorsForUserResponses, ListRecentErrorsResponses, ListSdgOutcomesForEntitiesData, ListSdgOutcomesForEntitiesErrors, ListSdgOutcomesForEntitiesResponses, ListSdgRevenueAlignmentData, ListSdgRevenueAlignmentErrors, ListSdgRevenueAlignmentResponses, ListSectorOptionsApiV1LabelsSectorsGetData, ListSectorOptionsApiV1LabelsSectorsGetResponses, ListSegmentOptionsApiV1LabelsSegmentsGetData, ListSegmentOptionsApiV1LabelsSegmentsGetResponses, ListSegmentsData, ListSegmentsErrors, ListSegmentsResponses, ListSourceBatchesData, ListSourceBatchesErrors, ListSourceBatchesResponses, ListSourcesData, ListSourcesErrors, ListSourcesResponses, ListThemeOptionsApiV1LabelsThemesGetData, ListThemeOptionsApiV1LabelsThemesGetResponses, ListUnitsData, ListUnitsErrors, ListUnitsResponses, LookupEntitiesData, LookupEntitiesErrors, LookupEntitiesResponses, LookupSfdrData, LookupSfdrErrors, LookupSfdrResponses, MergeEntitiesData, MergeEntitiesErrors, MergeEntitiesResponses, MergeSourcesData, MergeSourcesErrors, MergeSourcesResponses, MergeUnitsData, MergeUnitsErrors, MergeUnitsResponses, PatchUpdateEntityData, PatchUpdateEntityErrors, PatchUpdateEntityResponses, PutUpdateEntityData, PutUpdateEntityErrors, PutUpdateEntityResponses, ReturnIngestionTaskToQueueData, ReturnIngestionTaskToQueueErrors, ReturnIngestionTaskToQueueResponses, SendFeedbackData, SendFeedbackErrors, SendFeedbackResponses, SendIngestionTaskForAutoqaData, SendIngestionTaskForAutoqaErrors, SendIngestionTaskForAutoqaResponses, SetIngestionBatchPriorityData, SetIngestionBatchPriorityErrors, SetIngestionBatchPriorityResponses, SetSourceBatchPriorityData, SetSourceBatchPriorityErrors, SetSourceBatchPriorityResponses, StreamAcceptedFactsData, StreamAcceptedFactsErrors, StreamAcceptedFactsResponses, StreamKpiResultsData, StreamKpiResultsErrors, StreamKpiResultsResponses, SubmitFeedbackEmailData, SubmitFeedbackEmailErrors, SubmitFeedbackEmailResponses, SubmitIngestionTaskData, SubmitIngestionTaskErrors, SubmitIngestionTaskResponses, SubmitReportValueData, SubmitReportValueErrors, SubmitReportValueResponses, SubmitSourceTaskData, SubmitSourceTaskErrors, SubmitSourceTaskResponses, TriggerSdiRevenuePipelineData, TriggerSdiRevenuePipelineErrors, TriggerSdiRevenuePipelineResponses, TriggerValidationPipelineData, TriggerValidationPipelineResponses, UpdateElapsedFactTimeData, UpdateElapsedFactTimeErrors, UpdateElapsedFactTimeResponses, UpdateFactData, UpdateFactErrors, UpdateFactForExtractionStep2Data, UpdateFactForExtractionStep2Errors, UpdateFactForExtractionStep2Responses, UpdateFactForExtractionStepData, UpdateFactForExtractionStepErrors, UpdateFactForExtractionStepResponses, UpdateFactResponses, UpdateFeedbackData, UpdateFeedbackErrors, UpdateFeedbackResponses, UpdateHoldingData, UpdateHoldingErrors, UpdateHoldingResponses, UpdateIngestionTaskElapsedTimeData, UpdateIngestionTaskElapsedTimeErrors, UpdateIngestionTaskElapsedTimeResponses, UpdateKeywordData, UpdateKeywordErrors, UpdateKeywordResponses, UpdateKpiData, UpdateKpiErrors, UpdateKpiResponses, UpdateMetricData, UpdateMetricErrors, UpdateMetricResponses, UpdatePortfolioData, UpdatePortfolioErrors, UpdatePortfolioHoldingsData, UpdatePortfolioHoldingsErrors, UpdatePortfolioHoldingsResponses, UpdatePortfolioResponses, UpdateSegmentData, UpdateSegmentErrors, UpdateSegmentResponses, UpdateSourceData, UpdateSourceErrors, UpdateSourceResponses, UpdateSourceTaskElapsedTimeData, UpdateSourceTaskElapsedTimeErrors, UpdateSourceTaskElapsedTimeResponses, UpdateUnitData, UpdateUnitErrors, UpdateUnitResponses, UploadPortfolioData, UploadPortfolioErrors, UploadPortfolioResponses, UploadPortfolioWithFundHoldingsData, UploadPortfolioWithFundHoldingsErrors, UploadPortfolioWithFundHoldingsResponses, UploadSectorToTaxonomyData, UploadSectorToTaxonomyErrors, UploadSectorToTaxonomyResponses, UploadSegmentToTaxonomyData, UploadSegmentToTaxonomyErrors, UploadSegmentToTaxonomyResponses, UploadSourceFromFileData, UploadSourceFromFileErrors, UploadSourceFromFileResponses, UploadSourceFromUrlData, UploadSourceFromUrlErrors, UploadSourceFromUrlResponses, UploadTaxonomyAlignmentData, UploadTaxonomyAlignmentErrors, UploadTaxonomyAlignmentResponses, ValidateFactData, ValidateFactErrors, ValidateFactResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export class AcceptedFactsService {
    /**
     * List Accepted Fact Changes
     *
     * Returns all the changes for accepted facts.
     */
    public static listAcceptedFactChanges<ThrowOnError extends boolean = true>(options?: Options<ListAcceptedFactChangesData, ThrowOnError>): RequestResult<ListAcceptedFactChangesResponses, ListAcceptedFactChangesErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListAcceptedFactChangesResponses, ListAcceptedFactChangesErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/accepted_facts/changes',
            ...options
        });
    }
    
    /**
     * List Accepted Facts
     *
     * Lists base facts i.e. referenced data points from the system.
     *
     * ## Query Parameters:
     * This query can be modified by the following instructions.
     * These need to be compiled as a query parameter string,
     * and passed under the key of `q`
     * ```
     * e.g. ?q=limit%3D2000%26entity_id%3D2699
     * ```
     * Where %3D is a urlencoded `=`
     *
     *
     * ## filtering:
     * To filter the list pass in param values of key=val1[&key=val2...]
     * to indicate the values you wish to filter by
     *
     * ## modifiers:
     * You may prefix the keys with a modifier to change the logical test used in the
     * filter (the default being `=`):
     * * ! - not equal
     * * % - fuzzy - string only - Will search for substring `*val*`
     * * ~ - fuzzy not - string only - Will exclude things matching `*val*`
     *
     * ## sorting:
     * An optional key of `sort_by` may be included in the parameters to indicate the
     * parameters you wish to sort by. Prefixing the column name with a `-`
     * will change from ascending to descending
     *
     * ## page:
     * The key `page` specifies which page of results you wish to return
     *
     * ## limit:
     * The key `limit` specifies how many results you wish per page
     *
     */
    public static listAcceptedFacts<ThrowOnError extends boolean = true>(options?: Options<ListAcceptedFactsData, ThrowOnError>): RequestResult<ListAcceptedFactsResponses, ListAcceptedFactsErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListAcceptedFactsResponses, ListAcceptedFactsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/accepted_facts',
            ...options
        });
    }
    
    /**
     * Stream Accepted Facts
     *
     * Stream all Accepted Facts in JSONL format.
     * Each line is a complete JSON representation of a StreamAcceptedFact object.
     *
     * Performance option `batch_size`: default=5000
     */
    public static streamAcceptedFacts<ThrowOnError extends boolean = true>(options?: Options<StreamAcceptedFactsData, ThrowOnError>): RequestResult<StreamAcceptedFactsResponses, StreamAcceptedFactsErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<StreamAcceptedFactsResponses, StreamAcceptedFactsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/accepted_facts/stream',
            ...options
        });
    }
    
    /**
     * Get Accepted Fact
     *
     * Get a specific fact identified by `accepted_fact_id`
     */
    public static getAcceptedFact<ThrowOnError extends boolean = true>(options: Options<GetAcceptedFactData, ThrowOnError>): RequestResult<GetAcceptedFactResponses, GetAcceptedFactErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetAcceptedFactResponses, GetAcceptedFactErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/accepted_facts/{accepted_fact_id}',
            ...options
        });
    }
    
    /**
     * Get Fact Changes
     *
     * Returns all the changes for given fact_id.
     */
    public static getFactChanges<ThrowOnError extends boolean = true>(options: Options<GetFactChangesData, ThrowOnError>): RequestResult<GetFactChangesResponses, GetFactChangesErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetFactChangesResponses, GetFactChangesErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/accepted_facts/changes/{fact_id}',
            ...options
        });
    }
    
    /**
     * Get Accepted Fact Values
     */
    public static getAcceptedFactValues<ThrowOnError extends boolean = true>(options: Options<GetAcceptedFactValuesData, ThrowOnError>): RequestResult<GetAcceptedFactValuesResponses, GetAcceptedFactValuesErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetAcceptedFactValuesResponses, GetAcceptedFactValuesErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/accepted_facts/{entity_id}/{year}/{question_id}',
            ...options
        });
    }
}

export class BatchesService {
    /**
     * List Ingestion Batches
     */
    public static listIngestionBatches<ThrowOnError extends boolean = true>(options?: Options<ListIngestionBatchesData, ThrowOnError>): RequestResult<ListIngestionBatchesResponses, ListIngestionBatchesErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListIngestionBatchesResponses, ListIngestionBatchesErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/batches/ingestion',
            ...options
        });
    }
    
    /**
     * Get Ingestion Batch
     */
    public static getIngestionBatch<ThrowOnError extends boolean = true>(options: Options<GetIngestionBatchData, ThrowOnError>): RequestResult<GetIngestionBatchResponses, GetIngestionBatchErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetIngestionBatchResponses, GetIngestionBatchErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/batches/ingestion/{batch_id}',
            ...options
        });
    }
    
    /**
     * Set Priority Ingestion Batch
     *
     * Expects array of batch_ids in order of desired priority (highest first).
     * Sets the priority of tasks accordingly, ensuring they have higher priority
     * than batches not supplied to this call.
     */
    public static setIngestionBatchPriority<ThrowOnError extends boolean = true>(options: Options<SetIngestionBatchPriorityData, ThrowOnError>): RequestResult<SetIngestionBatchPriorityResponses, SetIngestionBatchPriorityErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<SetIngestionBatchPriorityResponses, SetIngestionBatchPriorityErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/batches/ingestion/set-priority',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Source Batches
     */
    public static listSourceBatches<ThrowOnError extends boolean = true>(options?: Options<ListSourceBatchesData, ThrowOnError>): RequestResult<ListSourceBatchesResponses, ListSourceBatchesErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListSourceBatchesResponses, ListSourceBatchesErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/batches/source',
            ...options
        });
    }
    
    /**
     * Get Source Batch
     */
    public static getSourceBatch<ThrowOnError extends boolean = true>(options: Options<GetSourceBatchData, ThrowOnError>): RequestResult<GetSourceBatchResponses, GetSourceBatchErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetSourceBatchResponses, GetSourceBatchErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/batches/source/{batch_id}',
            ...options
        });
    }
    
    /**
     * Set Priority Source Batch
     *
     * Expects array of batch_ids in order of desired priority (highest first).
     * Sets the priority of tasks accordingly, ensuring they have higher priority
     * than batches not supplied to this call.
     */
    public static setSourceBatchPriority<ThrowOnError extends boolean = true>(options: Options<SetSourceBatchPriorityData, ThrowOnError>): RequestResult<SetSourceBatchPriorityResponses, SetSourceBatchPriorityErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<SetSourceBatchPriorityResponses, SetSourceBatchPriorityErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/batches/source/set-priority',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class CoverageService {
    /**
     * Coverage Data
     */
    public static getQuestionCoverageData<ThrowOnError extends boolean = true>(options?: Options<GetQuestionCoverageDataData, ThrowOnError>): RequestResult<GetQuestionCoverageDataResponses, GetQuestionCoverageDataErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<GetQuestionCoverageDataResponses, GetQuestionCoverageDataErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/coverage',
            ...options
        });
    }
}

export class CompareService {
    /**
     * Export Compare Data
     *
     * Starts an asynchronous compare export.
     *
     * Streamed compare data export.
     */
    public static exportCompareData<ThrowOnError extends boolean = true>(options: Options<ExportCompareDataData, ThrowOnError>): RequestResult<ExportCompareDataResponses, ExportCompareDataErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<ExportCompareDataResponses, ExportCompareDataErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/compare/export',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class DataDictionaryService {
    /**
     * Get Data Dictionary
     *
     * Returns the list of Metrics, KPIs and Analysed KPIs
     *
     *
     * ## Query Parameters:
     * This query can be modified by the following instructions.
     * These need to be compiled as a query parameter string,
     * and passed under the key of `q`
     * ```
     * e.g. ?q=limit%3D2000%26entity_id%3D2699
     * ```
     * Where %3D is a urlencoded `=`
     *
     *
     * ## filtering:
     * To filter the list pass in param values of key=val1[&key=val2...]
     * to indicate the values you wish to filter by
     *
     * ## modifiers:
     * You may prefix the keys with a modifier to change the logical test used in the
     * filter (the default being `=`):
     * * ! - not equal
     * * % - fuzzy - string only - Will search for substring `*val*`
     * * ~ - fuzzy not - string only - Will exclude things matching `*val*`
     *
     * ## sorting:
     * An optional key of `sort_by` may be included in the parameters to indicate the
     * parameters you wish to sort by. Prefixing the column name with a `-`
     * will change from ascending to descending
     *
     * ## page:
     * The key `page` specifies which page of results you wish to return
     *
     * ## limit:
     * The key `limit` specifies how many results you wish per page
     *
     */
    public static getDataDictionary<ThrowOnError extends boolean = true>(options?: Options<GetDataDictionaryData, ThrowOnError>): RequestResult<GetDataDictionaryResponses, GetDataDictionaryErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<GetDataDictionaryResponses, GetDataDictionaryErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/data_dictionary',
            ...options
        });
    }
    
    /**
     * Export Data Dictionary
     *
     * Starts an asynchronous process to export an excel of the data dictionary.
     *
     *
     * The `result_id` in the returned data can be polled
     * for it's status at `/results?result_token=<result_id>`.
     *
     */
    public static exportDataDictionary<ThrowOnError extends boolean = true>(options?: Options<ExportDataDictionaryData, ThrowOnError>): RequestResult<ExportDataDictionaryResponses, ExportDataDictionaryErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).post<ExportDataDictionaryResponses, ExportDataDictionaryErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/data_dictionary/export',
            ...options
        });
    }
}

export class EntitiesService {
    /**
     * Upload Sector To Taxonomy
     *
     * Upload a csv or Excel file with columns of `factset_sector_id`, `taxon_id`
     * to update factset_sector -> taxon_id mappings
     */
    public static uploadSectorToTaxonomy<ThrowOnError extends boolean = true>(options: Options<UploadSectorToTaxonomyData, ThrowOnError>): RequestResult<UploadSectorToTaxonomyResponses, UploadSectorToTaxonomyErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<UploadSectorToTaxonomyResponses, UploadSectorToTaxonomyErrors, ThrowOnError, 'data'>({
            ...formDataBodySerializer,
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/sdg_revenue_alignment/upload_sector_to_taxonomy',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Upload Segment To Taxonomy
     *
     * Upload a csv or Excel file with columns of `segment_id`, `taxon_id`
     * to update NP segment -> taxon_id mappings
     */
    public static uploadSegmentToTaxonomy<ThrowOnError extends boolean = true>(options: Options<UploadSegmentToTaxonomyData, ThrowOnError>): RequestResult<UploadSegmentToTaxonomyResponses, UploadSegmentToTaxonomyErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<UploadSegmentToTaxonomyResponses, UploadSegmentToTaxonomyErrors, ThrowOnError, 'data'>({
            ...formDataBodySerializer,
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/sdg_revenue_alignment/upload_segment_to_taxonomy',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Upload Taxonomy Alignment
     *
     * Upload a csv or Excel file with columns of `taxon_id`, `sdg_alignment_type`
     * to update taxon_id -> sdg_alignment_type mappings
     */
    public static uploadTaxonomyAlignment<ThrowOnError extends boolean = true>(options: Options<UploadTaxonomyAlignmentData, ThrowOnError>): RequestResult<UploadTaxonomyAlignmentResponses, UploadTaxonomyAlignmentErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<UploadTaxonomyAlignmentResponses, UploadTaxonomyAlignmentErrors, ThrowOnError, 'data'>({
            ...formDataBodySerializer,
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/sdg_revenue_alignment/upload_taxonomy_alignment',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * List Sdg Revenue Alignment
     */
    public static listSdgRevenueAlignment<ThrowOnError extends boolean = true>(options?: Options<ListSdgRevenueAlignmentData, ThrowOnError>): RequestResult<ListSdgRevenueAlignmentResponses, ListSdgRevenueAlignmentErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListSdgRevenueAlignmentResponses, ListSdgRevenueAlignmentErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/sdg_revenue_alignment',
            ...options
        });
    }
    
    /**
     * Get Entity Activities Sdg Revenue Alignment Summary
     */
    public static getEntityActivitiesSdgRevenueAlignment<ThrowOnError extends boolean = true>(options: Options<GetEntityActivitiesSdgRevenueAlignmentData, ThrowOnError>): RequestResult<GetEntityActivitiesSdgRevenueAlignmentResponses, GetEntityActivitiesSdgRevenueAlignmentErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetEntityActivitiesSdgRevenueAlignmentResponses, GetEntityActivitiesSdgRevenueAlignmentErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/sdg_revenue_alignment/{entity_id}/activities',
            ...options
        });
    }
    
    /**
     * Entity Export Xlsx
     *
     * Download all data from the table as a minimally formatted excel.
     */
    public static exportEntityActivitiesXlsx<ThrowOnError extends boolean = true>(options: Options<ExportEntityActivitiesXlsxData, ThrowOnError>): RequestResult<ExportEntityActivitiesXlsxResponses, ExportEntityActivitiesXlsxErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<ExportEntityActivitiesXlsxResponses, ExportEntityActivitiesXlsxErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/sdg_revenue_alignment/{entity_id}/activities/export',
            ...options
        });
    }
    
    /**
     * Get Entity Activities Sdg Revenue Alignment By Taxon
     */
    public static getEntityActivitiesSdgRevenueAlignmentByTaxon<ThrowOnError extends boolean = true>(options: Options<GetEntityActivitiesSdgRevenueAlignmentByTaxonData, ThrowOnError>): RequestResult<GetEntityActivitiesSdgRevenueAlignmentByTaxonResponses, GetEntityActivitiesSdgRevenueAlignmentByTaxonErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetEntityActivitiesSdgRevenueAlignmentByTaxonResponses, GetEntityActivitiesSdgRevenueAlignmentByTaxonErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/sdg_revenue_alignment/{entity_id}/activities/{taxon_id}',
            ...options
        });
    }
    
    /**
     * Add Sdg Revenue Pipeline Approval
     */
    public static addSdgRevenuePipelineApproval<ThrowOnError extends boolean = true>(options: Options<AddSdgRevenuePipelineApprovalData, ThrowOnError>): RequestResult<AddSdgRevenuePipelineApprovalResponses, AddSdgRevenuePipelineApprovalErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<AddSdgRevenuePipelineApprovalResponses, AddSdgRevenuePipelineApprovalErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/sdg_revenue_alignment/approve_sdg_revenue_data',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Trigger Validation Pipeline
     */
    public static triggerValidationPipeline<ThrowOnError extends boolean = true>(options?: Options<TriggerValidationPipelineData, ThrowOnError>): RequestResult<TriggerValidationPipelineResponses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<TriggerValidationPipelineResponses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/sdg_revenue_alignment/trigger_validation_pipeline',
            ...options
        });
    }
    
    /**
     * Calculate Revenue Deltas
     */
    public static calculateRevenueDeltas<ThrowOnError extends boolean = true>(options: Options<CalculateRevenueDeltasData, ThrowOnError>): RequestResult<CalculateRevenueDeltasResponses, CalculateRevenueDeltasErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CalculateRevenueDeltasResponses, CalculateRevenueDeltasErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/sdg_revenue_alignment/deltas',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Export Sdg Revenue Data Changes
     */
    public static exportSdgRevenueDataChanges<ThrowOnError extends boolean = true>(options: Options<ExportSdgRevenueDataChangesData, ThrowOnError>): RequestResult<ExportSdgRevenueDataChangesResponses, ExportSdgRevenueDataChangesErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<ExportSdgRevenueDataChangesResponses, ExportSdgRevenueDataChangesErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/sdg_revenue_alignment/export_sdg_revenue_data_changes',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Temporary Table Dates
     */
    public static getTemporaryTableDates<ThrowOnError extends boolean = true>(options?: Options<GetTemporaryTableDatesData, ThrowOnError>): RequestResult<GetTemporaryTableDatesResponses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<GetTemporaryTableDatesResponses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/sdg_revenue_alignment/temporary_table_dates',
            ...options
        });
    }
    
    /**
     * Get Inconsistencies Summary
     */
    public static getInconsistenciesSummary<ThrowOnError extends boolean = true>(options: Options<GetInconsistenciesSummaryData, ThrowOnError>): RequestResult<GetInconsistenciesSummaryResponses, GetInconsistenciesSummaryErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<GetInconsistenciesSummaryResponses, GetInconsistenciesSummaryErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/sdg_revenue_alignment/get_inconsistencies_summary',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Validation Pipeline Status
     */
    public static getValidationPipelineStatus<ThrowOnError extends boolean = true>(options?: Options<GetValidationPipelineStatusData, ThrowOnError>): RequestResult<GetValidationPipelineStatusResponses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<GetValidationPipelineStatusResponses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/sdg_revenue_alignment/validation_pipeline_status',
            ...options
        });
    }
    
    /**
     * List Entities
     *
     * List entities from the database system. In addition to standard params the optional
     * `with_details` operator will include financial information about the entities.
     * If `with_details` is not set, or set to false then the return schema will be of type
     * `PaginatedResponse[Entity]` if `with_details` is set then it will be of type
     * `PaginatedResponse[EntityWithDetails]`
     *
     *
     * ## Query Parameters:
     * This query can be modified by the following instructions.
     * These need to be compiled as a query parameter string,
     * and passed under the key of `q`
     * ```
     * e.g. ?q=limit%3D2000%26entity_id%3D2699
     * ```
     * Where %3D is a urlencoded `=`
     *
     *
     * ## filtering:
     * To filter the list pass in param values of key=val1[&key=val2...]
     * to indicate the values you wish to filter by
     *
     * ## modifiers:
     * You may prefix the keys with a modifier to change the logical test used in the
     * filter (the default being `=`):
     * * ! - not equal
     * * % - fuzzy - string only - Will search for substring `*val*`
     * * ~ - fuzzy not - string only - Will exclude things matching `*val*`
     *
     * ## sorting:
     * An optional key of `sort_by` may be included in the parameters to indicate the
     * parameters you wish to sort by. Prefixing the column name with a `-`
     * will change from ascending to descending
     *
     * ## page:
     * The key `page` specifies which page of results you wish to return
     *
     * ## limit:
     * The key `limit` specifies how many results you wish per page
     *
     */
    public static listEntities<ThrowOnError extends boolean = true>(options?: Options<ListEntitiesData, ThrowOnError>): RequestResult<ListEntitiesResponses, ListEntitiesErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListEntitiesResponses, ListEntitiesErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities',
            ...options
        });
    }
    
    /**
     * Create Entity
     */
    public static createEntity<ThrowOnError extends boolean = true>(options: Options<CreateEntityData, ThrowOnError>): RequestResult<CreateEntityResponses, CreateEntityErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CreateEntityResponses, CreateEntityErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Identify Entities By Identifier
     *
     * Resolve identifiers of unknown type to the entities the user is entitled to.
     * Every exact match is returned with the identifier type it matched on.
     */
    public static identifyEntities<ThrowOnError extends boolean = true>(options: Options<IdentifyEntitiesData, ThrowOnError>): RequestResult<IdentifyEntitiesResponses, IdentifyEntitiesErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<IdentifyEntitiesResponses, IdentifyEntitiesErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/identify',
            ...options
        });
    }
    
    /**
     * List Inactive Entities
     *
     * List inactive entities from the database system.
     * If entities became inactive due to M&A action then information on the merger
     * will be returned.
     *
     * ## Query Parameters:
     * This query can be modified by the following instructions.
     * These need to be compiled as a query parameter string,
     * and passed under the key of `q`
     * ```
     * e.g. ?q=limit%3D2000%26entity_id%3D2699
     * ```
     * Where %3D is a urlencoded `=`
     *
     *
     * ## filtering:
     * To filter the list pass in param values of key=val1[&key=val2...]
     * to indicate the values you wish to filter by
     *
     * ## modifiers:
     * You may prefix the keys with a modifier to change the logical test used in the
     * filter (the default being `=`):
     * * ! - not equal
     * * % - fuzzy - string only - Will search for substring `*val*`
     * * ~ - fuzzy not - string only - Will exclude things matching `*val*`
     *
     * ## sorting:
     * An optional key of `sort_by` may be included in the parameters to indicate the
     * parameters you wish to sort by. Prefixing the column name with a `-`
     * will change from ascending to descending
     *
     * ## page:
     * The key `page` specifies which page of results you wish to return
     *
     * ## limit:
     * The key `limit` specifies how many results you wish per page
     *
     */
    public static listInactiveEntities<ThrowOnError extends boolean = true>(options?: Options<ListInactiveEntitiesData, ThrowOnError>): RequestResult<ListInactiveEntitiesResponses, ListInactiveEntitiesErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListInactiveEntitiesResponses, ListInactiveEntitiesErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/inactive',
            ...options
        });
    }
    
    /**
     * Get Inactive Entity
     *
     * Get an inactive entity identified by `entity_id`
     */
    public static getInactiveEntity<ThrowOnError extends boolean = true>(options: Options<GetInactiveEntityData, ThrowOnError>): RequestResult<GetInactiveEntityResponses, GetInactiveEntityErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetInactiveEntityResponses, GetInactiveEntityErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/inactive/{entity_id}',
            ...options
        });
    }
    
    /**
     * Merge Entities
     *
     * Mark a corporate action between two entities.
     *
     * - Duplicate entity → mark the source entity inactive and transfer all data to the
     * target.
     * - Relisting → keep the target (old entity) but update its name, primary ISIN
     * and FactSet ID from the source, then delete the source.
     * - Merger (absorption/amalgamation) → mark the source entity inactive and
     * record the merge.
     */
    public static mergeEntities<ThrowOnError extends boolean = true>(options: Options<MergeEntitiesData, ThrowOnError>): RequestResult<MergeEntitiesResponses, MergeEntitiesErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<MergeEntitiesResponses, MergeEntitiesErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/merge',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Entity
     */
    public static deleteEntity<ThrowOnError extends boolean = true>(options: Options<DeleteEntityData, ThrowOnError>): RequestResult<DeleteEntityResponses, DeleteEntityErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DeleteEntityResponses, DeleteEntityErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/{entity_id}',
            ...options
        });
    }
    
    /**
     * Get Entity
     *
     * Get the entity identified by `entity_id`
     */
    public static getEntity<ThrowOnError extends boolean = true>(options: Options<GetEntityData, ThrowOnError>): RequestResult<GetEntityResponses, GetEntityErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetEntityResponses, GetEntityErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/{entity_id}',
            ...options
        });
    }
    
    /**
     * Update Entity
     */
    public static patchUpdateEntity<ThrowOnError extends boolean = true>(options: Options<PatchUpdateEntityData, ThrowOnError>): RequestResult<PatchUpdateEntityResponses, PatchUpdateEntityErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).patch<PatchUpdateEntityResponses, PatchUpdateEntityErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/{entity_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Update Entity
     */
    public static putUpdateEntity<ThrowOnError extends boolean = true>(options: Options<PutUpdateEntityData, ThrowOnError>): RequestResult<PutUpdateEntityResponses, PutUpdateEntityErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<PutUpdateEntityResponses, PutUpdateEntityErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/{entity_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Entities Sdg Outcomes
     *
     * SDG Outcomes contributions.
     */
    public static listSdgOutcomesForEntities<ThrowOnError extends boolean = true>(options?: Options<ListSdgOutcomesForEntitiesData, ThrowOnError>): RequestResult<ListSdgOutcomesForEntitiesResponses, ListSdgOutcomesForEntitiesErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListSdgOutcomesForEntitiesResponses, ListSdgOutcomesForEntitiesErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/sdg_outcomes',
            ...options
        });
    }
    
    /**
     * Dashboard View
     *
     * Returns an array of the Impacts of entity identified by `entity_id`.
     * Each Impact Data pertains to a single theme.
     */
    public static getEntityDashboardData<ThrowOnError extends boolean = true>(options: Options<GetEntityDashboardDataData, ThrowOnError>): RequestResult<GetEntityDashboardDataResponses, GetEntityDashboardDataErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetEntityDashboardDataResponses, GetEntityDashboardDataErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/{entity_id}/dashboard',
            ...options
        });
    }
    
    /**
     * Dashboard Export
     */
    public static exportEntityDashboardXlsx<ThrowOnError extends boolean = true>(options: Options<ExportEntityDashboardXlsxData, ThrowOnError>): RequestResult<ExportEntityDashboardXlsxResponses, ExportEntityDashboardXlsxErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<ExportEntityDashboardXlsxResponses, ExportEntityDashboardXlsxErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/dashboard/export',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Export Entity
     *
     * Starts an asynchronous process to produce a summary report of the
     * entity identified by `entity_id`
     *
     *
     * The `result_id` in the returned data can be polled
     * for it's status at `/results?result_token=<result_id>`.
     *
     */
    public static exportEntity<ThrowOnError extends boolean = true>(options: Options<ExportEntityData, ThrowOnError>): RequestResult<ExportEntityResponses, ExportEntityErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<ExportEntityResponses, ExportEntityErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/{entity_id}/export',
            ...options
        });
    }
    
    /**
     * Lookup Entities
     */
    public static lookupEntities<ThrowOnError extends boolean = true>(options: Options<LookupEntitiesData, ThrowOnError>): RequestResult<LookupEntitiesResponses, LookupEntitiesErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<LookupEntitiesResponses, LookupEntitiesErrors, ThrowOnError, 'data'>({
            ...formDataBodySerializer,
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/lookup',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Sfdr Lookup
     */
    public static lookupSfdr<ThrowOnError extends boolean = true>(options: Options<LookupSfdrData, ThrowOnError>): RequestResult<LookupSfdrResponses, LookupSfdrErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<LookupSfdrResponses, LookupSfdrErrors, ThrowOnError, 'data'>({
            ...formDataBodySerializer,
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/sfdr_lookup',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Get Timeseries Facts
     *
     * Returns the timeseries of the base facts for the past `n_years`
     * for a given company starting with `end_year`.
     * Optional filters/sorts for (`question_id`, `unit.name`, `theme`, `sdg_goal`)
     */
    public static getTimeseriesFacts<ThrowOnError extends boolean = true>(options: Options<GetTimeseriesFactsData, ThrowOnError>): RequestResult<GetTimeseriesFactsResponses, GetTimeseriesFactsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetTimeseriesFactsResponses, GetTimeseriesFactsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/{entity_id}/timeseries',
            ...options
        });
    }
    
    /**
     * List Entity Portfolios
     *
     * Returns a list of all portfolios which the entity `entity_id` appears in
     */
    public static getEntityPortfolios<ThrowOnError extends boolean = true>(options: Options<GetEntityPortfoliosData, ThrowOnError>): RequestResult<GetEntityPortfoliosResponses, GetEntityPortfoliosErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetEntityPortfoliosResponses, GetEntityPortfoliosErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/{entity_id}/portfolios',
            ...options
        });
    }
    
    /**
     * Get Entity Breakdown In Fof Portfolio
     *
     * Returns a list of portfolio funds which the entity appears in,
     * and its total weight and value in a fund of funds portfolio.
     */
    public static getEntityBreakdownByFunds<ThrowOnError extends boolean = true>(options: Options<GetEntityBreakdownByFundsData, ThrowOnError>): RequestResult<GetEntityBreakdownByFundsResponses, GetEntityBreakdownByFundsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetEntityBreakdownByFundsResponses, GetEntityBreakdownByFundsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/{entity_id}/portfolios/{portfolio_id}/breakdown',
            ...options
        });
    }
    
    /**
     * Create Entities
     *
     * Upload a CSV file of entities to create. This sends a request to the np worker,
     * returning the result token of the job.
     */
    public static createEntities<ThrowOnError extends boolean = true>(options: Options<CreateEntitiesData, ThrowOnError>): RequestResult<CreateEntitiesResponses, CreateEntitiesErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CreateEntitiesResponses, CreateEntitiesErrors, ThrowOnError, 'data'>({
            ...formDataBodySerializer,
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/create_entities',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * List Question Entities Data
     */
    public static listQuestionEntitiesData<ThrowOnError extends boolean = true>(options: Options<ListQuestionEntitiesDataData, ThrowOnError>): RequestResult<ListQuestionEntitiesDataResponses, ListQuestionEntitiesDataErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<ListQuestionEntitiesDataResponses, ListQuestionEntitiesDataErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/question/{question_id}',
            ...options
        });
    }
    
    /**
     * Get Estimations Summary For Entity
     */
    public static getEntityEstimationsSummary<ThrowOnError extends boolean = true>(options: Options<GetEntityEstimationsSummaryData, ThrowOnError>): RequestResult<GetEntityEstimationsSummaryResponses, GetEntityEstimationsSummaryErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetEntityEstimationsSummaryResponses, GetEntityEstimationsSummaryErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/{entity_id}/estimations_summary',
            ...options
        });
    }
    
    /**
     * Get Estimated Data
     */
    public static getEstimatedData<ThrowOnError extends boolean = true>(options: Options<GetEstimatedDataData, ThrowOnError>): RequestResult<GetEstimatedDataResponses, GetEstimatedDataErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetEstimatedDataResponses, GetEstimatedDataErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/{entity_id}/estimated_data/{question_id}/{year}',
            ...options
        });
    }
    
    /**
     * Get Latest Data
     */
    public static getLatestData<ThrowOnError extends boolean = true>(options: Options<GetLatestDataData, ThrowOnError>): RequestResult<GetLatestDataResponses, GetLatestDataErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetLatestDataResponses, GetLatestDataErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/{entity_id}/latest_data/{question_id}',
            ...options
        });
    }
    
    /**
     * Get Entity Sdi Rationale
     *
     * Get the SDI rationale for an entity
     */
    public static getEntitySdiRationale<ThrowOnError extends boolean = true>(options: Options<GetEntitySdiRationaleData, ThrowOnError>): RequestResult<GetEntitySdiRationaleResponses, GetEntitySdiRationaleErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetEntitySdiRationaleResponses, GetEntitySdiRationaleErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entities/{entity_id}/sdi_rationale',
            ...options
        });
    }
}

export class EnumsService {
    /**
     * List Enums
     *
     * Returns a list of all Enums in the Netpurpose Universe
     */
    public static listEnums<ThrowOnError extends boolean = true>(options?: Options<ListEnumsData, ThrowOnError>): RequestResult<ListEnumsResponses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListEnumsResponses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/enums',
            ...options
        });
    }
    
    /**
     * Get Enum
     *
     * Return all possible values of the enum in `enum`
     */
    public static getEnum<ThrowOnError extends boolean = true>(options: Options<GetEnumData, ThrowOnError>): RequestResult<GetEnumResponses, GetEnumErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetEnumResponses, GetEnumErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/enums/{enum}',
            ...options
        });
    }
    
    /**
     * Get Enum Details
     *
     * Return all possible values of the enum in `enum` with their descriptions.
     * Only available for enums that have descriptions.
     */
    public static getEnumDetails<ThrowOnError extends boolean = true>(options: Options<GetEnumDetailsData, ThrowOnError>): RequestResult<GetEnumDetailsResponses, GetEnumDetailsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetEnumDetailsResponses, GetEnumDetailsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/enums/{enum}/details',
            ...options
        });
    }
}

export class ErrorsService {
    /**
     * All Recent Errors
     *
     * Want to get a summary of the most common errors which have happened for this metric
     * across all users, but filtered to relative recency.
     */
    public static listRecentErrors<ThrowOnError extends boolean = true>(options: Options<ListRecentErrorsData, ThrowOnError>): RequestResult<ListRecentErrorsResponses, ListRecentErrorsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<ListRecentErrorsResponses, ListRecentErrorsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/errors/recent/{metric_id}',
            ...options
        });
    }
    
    /**
     * User Recent Errors
     *
     * Get the recent errors for the requested user only. Same base filters as above.
     */
    public static listRecentErrorsForUser<ThrowOnError extends boolean = true>(options: Options<ListRecentErrorsForUserData, ThrowOnError>): RequestResult<ListRecentErrorsForUserResponses, ListRecentErrorsForUserErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<ListRecentErrorsForUserResponses, ListRecentErrorsForUserErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/errors/recent/{metric_id}/{user_id}',
            ...options
        });
    }
}

export class EstimatedService {
    /**
     * List Datapoints
     */
    public static listEstimatedData<ThrowOnError extends boolean = true>(options?: Options<ListEstimatedDataData, ThrowOnError>): RequestResult<ListEstimatedDataResponses, ListEstimatedDataErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListEstimatedDataResponses, ListEstimatedDataErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/estimations/',
            ...options
        });
    }
}

export class FactsService {
    /**
     * List Facts
     */
    public static listFacts<ThrowOnError extends boolean = true>(options?: Options<ListFactsData, ThrowOnError>): RequestResult<ListFactsResponses, ListFactsErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListFactsResponses, ListFactsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facts',
            ...options
        });
    }
    
    /**
     * Create Fact
     */
    public static createFact<ThrowOnError extends boolean = true>(options: Options<CreateFactData, ThrowOnError>): RequestResult<CreateFactResponses, CreateFactErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CreateFactResponses, CreateFactErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Eu Sfdr Facts
     */
    public static listEuSfdrFacts<ThrowOnError extends boolean = true>(options?: Options<ListEuSfdrFactsData, ThrowOnError>): RequestResult<ListEuSfdrFactsResponses, ListEuSfdrFactsErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListEuSfdrFactsResponses, ListEuSfdrFactsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facts/eu_sfdr',
            ...options
        });
    }
    
    /**
     * Get Eu Sfdr Fact
     */
    public static getEuSfdrFact<ThrowOnError extends boolean = true>(options: Options<GetEuSfdrFactData, ThrowOnError>): RequestResult<GetEuSfdrFactResponses, GetEuSfdrFactErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetEuSfdrFactResponses, GetEuSfdrFactErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facts/eu_sfdr/{fact_id}',
            ...options
        });
    }
    
    /**
     * Delete Fact
     */
    public static deleteFact<ThrowOnError extends boolean = true>(options: Options<DeleteFactData, ThrowOnError>): RequestResult<DeleteFactResponses, DeleteFactErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DeleteFactResponses, DeleteFactErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facts/{fact_id}',
            ...options
        });
    }
    
    /**
     * Get Fact
     */
    public static getFact<ThrowOnError extends boolean = true>(options: Options<GetFactData, ThrowOnError>): RequestResult<GetFactResponses, GetFactErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetFactResponses, GetFactErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facts/{fact_id}',
            ...options
        });
    }
    
    /**
     * Admin Providing Feedback
     */
    public static updateFact<ThrowOnError extends boolean = true>(options: Options<UpdateFactData, ThrowOnError>): RequestResult<UpdateFactResponses, UpdateFactErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateFactResponses, UpdateFactErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facts/{fact_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Candidate Fact
     */
    public static getCandidateFact<ThrowOnError extends boolean = true>(options: Options<GetCandidateFactData, ThrowOnError>): RequestResult<GetCandidateFactResponses, GetCandidateFactErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetCandidateFactResponses, GetCandidateFactErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facts/{fact_id}/candidate',
            ...options
        });
    }
    
    /**
     * Update Elapsed
     */
    public static updateElapsedFactTime<ThrowOnError extends boolean = true>(options: Options<UpdateElapsedFactTimeData, ThrowOnError>): RequestResult<UpdateElapsedFactTimeResponses, UpdateElapsedFactTimeErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateElapsedFactTimeResponses, UpdateElapsedFactTimeErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facts/{fact_id}/update_elapsed',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Update Eu Sfdr Fact
     */
    public static updateFactForExtractionStep<ThrowOnError extends boolean = true>(options: Options<UpdateFactForExtractionStepData, ThrowOnError>): RequestResult<UpdateFactForExtractionStepResponses, UpdateFactForExtractionStepErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateFactForExtractionStepResponses, UpdateFactForExtractionStepErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facts/eu_sfdr/{fact_id}/{extraction_step}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Update Fact
     */
    public static updateFactForExtractionStep2<ThrowOnError extends boolean = true>(options: Options<UpdateFactForExtractionStep2Data, ThrowOnError>): RequestResult<UpdateFactForExtractionStep2Responses, UpdateFactForExtractionStep2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateFactForExtractionStep2Responses, UpdateFactForExtractionStep2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facts/{fact_id}/{extraction_step}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Send For Validation
     */
    public static validateFact<ThrowOnError extends boolean = true>(options: Options<ValidateFactData, ThrowOnError>): RequestResult<ValidateFactResponses, ValidateFactErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<ValidateFactResponses, ValidateFactErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facts/validate',
            ...options
        });
    }
    
    /**
     * Create New Facts
     *
     * Upload a CSV file of new facts to create. This is parsed and
     * creates new facts in the NEW state.
     */
    public static createNewFacts<ThrowOnError extends boolean = true>(options: Options<CreateNewFactsData, ThrowOnError>): RequestResult<CreateNewFactsResponses, CreateNewFactsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CreateNewFactsResponses, CreateNewFactsErrors, ThrowOnError, 'data'>({
            ...formDataBodySerializer,
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facts/create_new_facts',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Create Facts For Theme
     */
    public static createFactsForTheme<ThrowOnError extends boolean = true>(options: Options<CreateFactsForThemeData, ThrowOnError>): RequestResult<CreateFactsForThemeResponses, CreateFactsForThemeErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CreateFactsForThemeResponses, CreateFactsForThemeErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facts/factset',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Bulk Accept Facts From Query
     */
    public static bulkAcceptFactsFromQuery<ThrowOnError extends boolean = true>(options?: Options<BulkAcceptFactsFromQueryData, ThrowOnError>): RequestResult<BulkAcceptFactsFromQueryResponses, BulkAcceptFactsFromQueryErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).patch<BulkAcceptFactsFromQueryResponses, BulkAcceptFactsFromQueryErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facts/accept',
            ...options
        });
    }
    
    /**
     * Bulk Accept From Csv
     *
     * Accepts multiple facts based on a provided CSV file.
     */
    public static bulkAcceptFromCsv<ThrowOnError extends boolean = true>(options: Options<BulkAcceptFromCsvData, ThrowOnError>): RequestResult<BulkAcceptFromCsvResponses, BulkAcceptFromCsvErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<BulkAcceptFromCsvResponses, BulkAcceptFromCsvErrors, ThrowOnError, 'data'>({
            ...formDataBodySerializer,
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facts/bulk_accept',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Bulk Delete Facts
     *
     * Deletes multiple facts based on a provided CSV file.
     */
    public static bulkDeleteFacts<ThrowOnError extends boolean = true>(options: Options<BulkDeleteFactsData, ThrowOnError>): RequestResult<BulkDeleteFactsResponses, BulkDeleteFactsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<BulkDeleteFactsResponses, BulkDeleteFactsErrors, ThrowOnError, 'data'>({
            ...formDataBodySerializer,
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facts/bulk_delete',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
}

export class FeedbackService {
    /**
     * Submit Feedback Email
     *
     * Send feedback from user
     */
    public static submitFeedbackEmail<ThrowOnError extends boolean = true>(options: Options<SubmitFeedbackEmailData, ThrowOnError>): RequestResult<SubmitFeedbackEmailResponses, SubmitFeedbackEmailErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<SubmitFeedbackEmailResponses, SubmitFeedbackEmailErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/feedback/submit_feedback',
            ...options
        });
    }
    
    /**
     * Submit Report Value
     *
     * Send feedback from user
     */
    public static submitReportValue<ThrowOnError extends boolean = true>(options: Options<SubmitReportValueData, ThrowOnError>): RequestResult<SubmitReportValueResponses, SubmitReportValueErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<SubmitReportValueResponses, SubmitReportValueErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/feedback/submit_report_value',
            ...options
        });
    }
}

export class HoldingsService {
    /**
     * List Holdings
     *
     * DEPRECATED: Use `/portfolios/:portfolio_id/holdings` instead.
     *
     * @deprecated
     */
    public static listHoldings<ThrowOnError extends boolean = true>(options?: Options<ListHoldingsData, ThrowOnError>): RequestResult<ListHoldingsResponses, ListHoldingsErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListHoldingsResponses, ListHoldingsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/holdings',
            ...options
        });
    }
    
    /**
     * Update Holding
     *
     * Update the holding identified by `holding_id`.
     */
    public static updateHolding<ThrowOnError extends boolean = true>(options: Options<UpdateHoldingData, ThrowOnError>): RequestResult<UpdateHoldingResponses, UpdateHoldingErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateHoldingResponses, UpdateHoldingErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/holdings/{holding_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Export Holdings
     *
     * Exports portfolio holdings to an Excel file.
     *
     * If `snapshot_id` is not provided, defaults to the latest snapshot for the portfolio.
     * Returns a streaming response containing the generated Excel file.
     */
    public static exportHoldings<ThrowOnError extends boolean = true>(options: Options<ExportHoldingsData, ThrowOnError>): RequestResult<ExportHoldingsResponses, ExportHoldingsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<ExportHoldingsResponses, ExportHoldingsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/holdings/export',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class KeywordsService {
    /**
     * List Objects
     */
    public static listKeywords<ThrowOnError extends boolean = true>(options?: Options<ListKeywordsData, ThrowOnError>): RequestResult<ListKeywordsResponses, ListKeywordsErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListKeywordsResponses, ListKeywordsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/keywords',
            ...options
        });
    }
    
    /**
     * Create Keyword
     */
    public static createKeyword<ThrowOnError extends boolean = true>(options: Options<CreateKeywordData, ThrowOnError>): RequestResult<CreateKeywordResponses, CreateKeywordErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CreateKeywordResponses, CreateKeywordErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/keywords',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Object
     */
    public static deleteKeyword<ThrowOnError extends boolean = true>(options: Options<DeleteKeywordData, ThrowOnError>): RequestResult<DeleteKeywordResponses, DeleteKeywordErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DeleteKeywordResponses, DeleteKeywordErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/keywords/{keyword_id}',
            ...options
        });
    }
    
    /**
     * Get Keyword
     */
    public static getKeyword<ThrowOnError extends boolean = true>(options: Options<GetKeywordData, ThrowOnError>): RequestResult<GetKeywordResponses, GetKeywordErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetKeywordResponses, GetKeywordErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/keywords/{keyword_id}',
            ...options
        });
    }
    
    /**
     * Update Keyword
     */
    public static updateKeyword<ThrowOnError extends boolean = true>(options: Options<UpdateKeywordData, ThrowOnError>): RequestResult<UpdateKeywordResponses, UpdateKeywordErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateKeywordResponses, UpdateKeywordErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/keywords/{keyword_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class KpiResultsService {
    /**
     * List Kpi Results
     *
     * Lists KPI Results. These are the computed values based on the raw data points
     * found in `accepted_facts`.
     *
     *
     * ## Query Parameters:
     * This query can be modified by the following instructions.
     * These need to be compiled as a query parameter string,
     * and passed under the key of `q`
     * ```
     * e.g. ?q=limit%3D2000%26entity_id%3D2699
     * ```
     * Where %3D is a urlencoded `=`
     *
     *
     * ## filtering:
     * To filter the list pass in param values of key=val1[&key=val2...]
     * to indicate the values you wish to filter by
     *
     * ## modifiers:
     * You may prefix the keys with a modifier to change the logical test used in the
     * filter (the default being `=`):
     * * ! - not equal
     * * % - fuzzy - string only - Will search for substring `*val*`
     * * ~ - fuzzy not - string only - Will exclude things matching `*val*`
     *
     * ## sorting:
     * An optional key of `sort_by` may be included in the parameters to indicate the
     * parameters you wish to sort by. Prefixing the column name with a `-`
     * will change from ascending to descending
     *
     * ## page:
     * The key `page` specifies which page of results you wish to return
     *
     * ## limit:
     * The key `limit` specifies how many results you wish per page
     *
     */
    public static listKpiResults<ThrowOnError extends boolean = true>(options?: Options<ListKpiResultsData, ThrowOnError>): RequestResult<ListKpiResultsResponses, ListKpiResultsErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListKpiResultsResponses, ListKpiResultsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/kpi_results',
            ...options
        });
    }
    
    /**
     * Stream Kpi Results
     *
     * Stream all KPI Results in JSONL/NDJSON format.
     */
    public static streamKpiResults<ThrowOnError extends boolean = true>(options?: Options<StreamKpiResultsData, ThrowOnError>): RequestResult<StreamKpiResultsResponses, StreamKpiResultsErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<StreamKpiResultsResponses, StreamKpiResultsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/kpi_results/stream',
            ...options
        });
    }
    
    /**
     * Kpi Results Detail
     *
     * Return a singe KPI Result with the formatted calculation tree.
     */
    public static getKpiResult<ThrowOnError extends boolean = true>(options: Options<GetKpiResultData, ThrowOnError>): RequestResult<GetKpiResultResponses, GetKpiResultErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetKpiResultResponses, GetKpiResultErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/kpi_results/{kpi_result_id}',
            ...options
        });
    }
}

export class KpisService {
    /**
     * List Kpis
     *
     * List the KPIs and their definitions in the system. The corresponding data can be
     * retreived from `/kpi_results`
     *
     *
     * ## Query Parameters:
     * This query can be modified by the following instructions.
     * These need to be compiled as a query parameter string,
     * and passed under the key of `q`
     * ```
     * e.g. ?q=limit%3D2000%26entity_id%3D2699
     * ```
     * Where %3D is a urlencoded `=`
     *
     *
     * ## filtering:
     * To filter the list pass in param values of key=val1[&key=val2...]
     * to indicate the values you wish to filter by
     *
     * ## modifiers:
     * You may prefix the keys with a modifier to change the logical test used in the
     * filter (the default being `=`):
     * * ! - not equal
     * * % - fuzzy - string only - Will search for substring `*val*`
     * * ~ - fuzzy not - string only - Will exclude things matching `*val*`
     *
     * ## sorting:
     * An optional key of `sort_by` may be included in the parameters to indicate the
     * parameters you wish to sort by. Prefixing the column name with a `-`
     * will change from ascending to descending
     *
     * ## page:
     * The key `page` specifies which page of results you wish to return
     *
     * ## limit:
     * The key `limit` specifies how many results you wish per page
     *
     */
    public static listKpis<ThrowOnError extends boolean = true>(options?: Options<ListKpisData, ThrowOnError>): RequestResult<ListKpisResponses, ListKpisErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListKpisResponses, ListKpisErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/kpis',
            ...options
        });
    }
    
    /**
     * Create Kpi
     */
    public static createKpi<ThrowOnError extends boolean = true>(options: Options<CreateKpiData, ThrowOnError>): RequestResult<CreateKpiResponses, CreateKpiErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CreateKpiResponses, CreateKpiErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/kpis',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Kpi
     */
    public static deleteKpi<ThrowOnError extends boolean = true>(options: Options<DeleteKpiData, ThrowOnError>): RequestResult<DeleteKpiResponses, DeleteKpiErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DeleteKpiResponses, DeleteKpiErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/kpis/{kpi_id}',
            ...options
        });
    }
    
    /**
     * Get Kpi
     *
     * Get the info about the KPI identified by `kpi_id`
     */
    public static getKpi<ThrowOnError extends boolean = true>(options: Options<GetKpiData, ThrowOnError>): RequestResult<GetKpiResponses, GetKpiErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetKpiResponses, GetKpiErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/kpis/{kpi_id}',
            ...options
        });
    }
    
    /**
     * Update Kpi
     */
    public static updateKpi<ThrowOnError extends boolean = true>(options: Options<UpdateKpiData, ThrowOnError>): RequestResult<UpdateKpiResponses, UpdateKpiErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateKpiResponses, UpdateKpiErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/kpis/{kpi_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class LabelsService {
    /**
     * List Theme Options
     *
     * Returns Themes that can be used as labels.
     *
     * Note that keys and values are the same, because the labels endpoint
     * specification requires a dictionary of key:values to be returned.
     */
    public static listThemeOptionsApiV1LabelsThemesGet<ThrowOnError extends boolean = true>(options?: Options<ListThemeOptionsApiV1LabelsThemesGetData, ThrowOnError>): RequestResult<ListThemeOptionsApiV1LabelsThemesGetResponses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListThemeOptionsApiV1LabelsThemesGetResponses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/labels/themes',
            ...options
        });
    }
    
    /**
     * List Sector Options
     *
     * Returns the sectors of active companies, which can be used to filter entities
     * by `sector`.
     *
     * Note that keys and values are the same, because the labels endpoint
     * specification requires a dictionary of key:values to be returned.
     */
    public static listSectorOptionsApiV1LabelsSectorsGet<ThrowOnError extends boolean = true>(options?: Options<ListSectorOptionsApiV1LabelsSectorsGetData, ThrowOnError>): RequestResult<ListSectorOptionsApiV1LabelsSectorsGetResponses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListSectorOptionsApiV1LabelsSectorsGetResponses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/labels/sectors',
            ...options
        });
    }
    
    /**
     * List Segment Options
     *
     * Returns Segment categories and segment classes that can be used as labels,
     * in the form segment_category:segment_class.
     *
     * Note that keys and values are the same, because the labels endpoint
     * specification requires a dictionary of key:values to be returned, even
     * if they are the same.
     */
    public static listSegmentOptionsApiV1LabelsSegmentsGet<ThrowOnError extends boolean = true>(options?: Options<ListSegmentOptionsApiV1LabelsSegmentsGetData, ThrowOnError>): RequestResult<ListSegmentOptionsApiV1LabelsSegmentsGetResponses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListSegmentOptionsApiV1LabelsSegmentsGetResponses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/labels/segments',
            ...options
        });
    }
}

export class MetricsService {
    /**
     * List Metrics
     *
     * Lists metric definitions. Metrics define the raw data points used in our system.
     * The corresponding data can be retreived from `accepted_facts`
     *
     *
     * ## Query Parameters:
     * This query can be modified by the following instructions.
     * These need to be compiled as a query parameter string,
     * and passed under the key of `q`
     * ```
     * e.g. ?q=limit%3D2000%26entity_id%3D2699
     * ```
     * Where %3D is a urlencoded `=`
     *
     *
     * ## filtering:
     * To filter the list pass in param values of key=val1[&key=val2...]
     * to indicate the values you wish to filter by
     *
     * ## modifiers:
     * You may prefix the keys with a modifier to change the logical test used in the
     * filter (the default being `=`):
     * * ! - not equal
     * * % - fuzzy - string only - Will search for substring `*val*`
     * * ~ - fuzzy not - string only - Will exclude things matching `*val*`
     *
     * ## sorting:
     * An optional key of `sort_by` may be included in the parameters to indicate the
     * parameters you wish to sort by. Prefixing the column name with a `-`
     * will change from ascending to descending
     *
     * ## page:
     * The key `page` specifies which page of results you wish to return
     *
     * ## limit:
     * The key `limit` specifies how many results you wish per page
     *
     */
    public static listMetrics<ThrowOnError extends boolean = true>(options?: Options<ListMetricsData, ThrowOnError>): RequestResult<ListMetricsResponses, ListMetricsErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListMetricsResponses, ListMetricsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/metrics',
            ...options
        });
    }
    
    /**
     * Create Metric
     */
    public static createMetric<ThrowOnError extends boolean = true>(options: Options<CreateMetricData, ThrowOnError>): RequestResult<CreateMetricResponses, CreateMetricErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CreateMetricResponses, CreateMetricErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/metrics',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Metric
     */
    public static deleteMetric<ThrowOnError extends boolean = true>(options: Options<DeleteMetricData, ThrowOnError>): RequestResult<DeleteMetricResponses, DeleteMetricErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DeleteMetricResponses, DeleteMetricErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/metrics/{metric_id}',
            ...options
        });
    }
    
    /**
     * Get Metric
     *
     * Get the metric identified by `metric_id`
     */
    public static getMetric<ThrowOnError extends boolean = true>(options: Options<GetMetricData, ThrowOnError>): RequestResult<GetMetricResponses, GetMetricErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetMetricResponses, GetMetricErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/metrics/{metric_id}',
            ...options
        });
    }
    
    /**
     * Update Metrics
     */
    public static updateMetric<ThrowOnError extends boolean = true>(options: Options<UpdateMetricData, ThrowOnError>): RequestResult<UpdateMetricResponses, UpdateMetricErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateMetricResponses, UpdateMetricErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/metrics/{metric_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class PortfoliosService {
    /**
     * List Portfolios
     *
     * Lists all portfolios in your account.
     *
     *
     * ## Query Parameters:
     * This query can be modified by the following instructions.
     * These need to be compiled as a query parameter string,
     * and passed under the key of `q`
     * ```
     * e.g. ?q=limit%3D2000%26entity_id%3D2699
     * ```
     * Where %3D is a urlencoded `=`
     *
     *
     * ## filtering:
     * To filter the list pass in param values of key=val1[&key=val2...]
     * to indicate the values you wish to filter by
     *
     * ## modifiers:
     * You may prefix the keys with a modifier to change the logical test used in the
     * filter (the default being `=`):
     * * ! - not equal
     * * % - fuzzy - string only - Will search for substring `*val*`
     * * ~ - fuzzy not - string only - Will exclude things matching `*val*`
     *
     * ## sorting:
     * An optional key of `sort_by` may be included in the parameters to indicate the
     * parameters you wish to sort by. Prefixing the column name with a `-`
     * will change from ascending to descending
     *
     * ## page:
     * The key `page` specifies which page of results you wish to return
     *
     * ## limit:
     * The key `limit` specifies how many results you wish per page
     *
     */
    public static listPortfolios<ThrowOnError extends boolean = true>(options?: Options<ListPortfoliosData, ThrowOnError>): RequestResult<ListPortfoliosResponses, ListPortfoliosErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListPortfoliosResponses, ListPortfoliosErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios',
            ...options
        });
    }
    
    /**
     * List Portfolio Holdings
     *
     * Lists portfolio holdings.
     *
     *
     * ## Query Parameters:
     * This query can be modified by the following instructions.
     * These need to be compiled as a query parameter string,
     * and passed under the key of `q`
     * ```
     * e.g. ?q=limit%3D2000%26entity_id%3D2699
     * ```
     * Where %3D is a urlencoded `=`
     *
     *
     * ## filtering:
     * To filter the list pass in param values of key=val1[&key=val2...]
     * to indicate the values you wish to filter by
     *
     * ## modifiers:
     * You may prefix the keys with a modifier to change the logical test used in the
     * filter (the default being `=`):
     * * ! - not equal
     * * % - fuzzy - string only - Will search for substring `*val*`
     * * ~ - fuzzy not - string only - Will exclude things matching `*val*`
     *
     * ## sorting:
     * An optional key of `sort_by` may be included in the parameters to indicate the
     * parameters you wish to sort by. Prefixing the column name with a `-`
     * will change from ascending to descending
     *
     * ## page:
     * The key `page` specifies which page of results you wish to return
     *
     * ## limit:
     * The key `limit` specifies how many results you wish per page
     *
     */
    public static listPortfolioHoldings<ThrowOnError extends boolean = true>(options: Options<ListPortfolioHoldingsData, ThrowOnError>): RequestResult<ListPortfolioHoldingsResponses, ListPortfolioHoldingsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<ListPortfolioHoldingsResponses, ListPortfolioHoldingsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/{portfolio_id}/holdings',
            ...options
        });
    }
    
    /**
     * List Portfolio With Funds Holdings By Company
     *
     * Lists portfolio with funds holdings by company.
     *
     *
     * ## Query Parameters:
     * This query can be modified by the following instructions.
     * These need to be compiled as a query parameter string,
     * and passed under the key of `q`
     * ```
     * e.g. ?q=limit%3D2000%26entity_id%3D2699
     * ```
     * Where %3D is a urlencoded `=`
     *
     *
     * ## filtering:
     * To filter the list pass in param values of key=val1[&key=val2...]
     * to indicate the values you wish to filter by
     *
     * ## modifiers:
     * You may prefix the keys with a modifier to change the logical test used in the
     * filter (the default being `=`):
     * * ! - not equal
     * * % - fuzzy - string only - Will search for substring `*val*`
     * * ~ - fuzzy not - string only - Will exclude things matching `*val*`
     *
     * ## sorting:
     * An optional key of `sort_by` may be included in the parameters to indicate the
     * parameters you wish to sort by. Prefixing the column name with a `-`
     * will change from ascending to descending
     *
     * ## page:
     * The key `page` specifies which page of results you wish to return
     *
     * ## limit:
     * The key `limit` specifies how many results you wish per page
     *
     */
    public static listPortfolioWithFundsHoldingsByCompany<ThrowOnError extends boolean = true>(options: Options<ListPortfolioWithFundsHoldingsByCompanyData, ThrowOnError>): RequestResult<ListPortfolioWithFundsHoldingsByCompanyResponses, ListPortfolioWithFundsHoldingsByCompanyErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<ListPortfolioWithFundsHoldingsByCompanyResponses, ListPortfolioWithFundsHoldingsByCompanyErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/{portfolio_id}/holdings_by_company',
            ...options
        });
    }
    
    /**
     * List Portfolio Sources
     *
     * Get all sources referenced by all covered entities in the portfolio identified
     * by `portfolio_id`.
     */
    public static listPortfolioSources<ThrowOnError extends boolean = true>(options: Options<ListPortfolioSourcesData, ThrowOnError>): RequestResult<ListPortfolioSourcesResponses, ListPortfolioSourcesErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<ListPortfolioSourcesResponses, ListPortfolioSourcesErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/{portfolio_id}/sources',
            ...options
        });
    }
    
    /**
     * Delete Portfolio
     *
     * Delete the portfolio and all associated holdings identified by `portfolio_id`
     */
    public static deletePortfolio<ThrowOnError extends boolean = true>(options: Options<DeletePortfolioData, ThrowOnError>): RequestResult<DeletePortfolioResponses, DeletePortfolioErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DeletePortfolioResponses, DeletePortfolioErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/{portfolio_id}',
            ...options
        });
    }
    
    /**
     * Get Portfolio With Holdings
     *
     * Get portfolio identified by `portfolio_id`. Includes information on the coverage of
     * the entities linked by the holdings.
     */
    public static getPortfolioWithHoldings<ThrowOnError extends boolean = true>(options: Options<GetPortfolioWithHoldingsData, ThrowOnError>): RequestResult<GetPortfolioWithHoldingsResponses, GetPortfolioWithHoldingsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetPortfolioWithHoldingsResponses, GetPortfolioWithHoldingsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/{portfolio_id}',
            ...options
        });
    }
    
    /**
     * Update Portfolio
     *
     * Updates the portfolio identified by `portfolio_id`
     */
    public static updatePortfolio<ThrowOnError extends boolean = true>(options: Options<UpdatePortfolioData, ThrowOnError>): RequestResult<UpdatePortfolioResponses, UpdatePortfolioErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdatePortfolioResponses, UpdatePortfolioErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/{portfolio_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Export Portfolio
     *
     * Starts an asynchronous portfolio export.
     *
     * The `metric_config_id` field in the body can be:
     * - UUID(int=0): run export with major metrics & KPIs.
     * - UUID(abc): run export with metrics_config <abc>
     *
     *
     * The `result_id` in the returned data can be polled
     * for it's status at `/results?result_token=<result_id>`.
     *
     */
    public static exportPortfolio<ThrowOnError extends boolean = true>(options: Options<ExportPortfolioData, ThrowOnError>): RequestResult<ExportPortfolioResponses, ExportPortfolioErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<ExportPortfolioResponses, ExportPortfolioErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/export',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Export Portfolio Pai
     *
     * Starts an asynchronous portfolio PAI export.
     *
     *
     * The `result_id` in the returned data can be polled
     * for it's status at `/results?result_token=<result_id>`.
     *
     */
    public static exportPortfolioPai<ThrowOnError extends boolean = true>(options: Options<ExportPortfolioPaiData, ThrowOnError>): RequestResult<ExportPortfolioPaiResponses, ExportPortfolioPaiErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<ExportPortfolioPaiResponses, ExportPortfolioPaiErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/pai/export',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Export Portfolio Sdg
     *
     * Starts an asynchronous portfolio SDG export.
     *
     *
     * The `result_id` in the returned data can be polled
     * for it's status at `/results?result_token=<result_id>`.
     *
     */
    public static exportPortfolioSdg<ThrowOnError extends boolean = true>(options: Options<ExportPortfolioSdgData, ThrowOnError>): RequestResult<ExportPortfolioSdgResponses, ExportPortfolioSdgErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<ExportPortfolioSdgResponses, ExportPortfolioSdgErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/sdg/export',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Export Portfolio Sdg Revenue
     *
     * Starts an asynchronous portfolio SDG revenue export.
     *
     *
     * The `result_id` in the returned data can be polled
     * for it's status at `/results?result_token=<result_id>`.
     *
     */
    public static exportPortfolioSdgRevenue<ThrowOnError extends boolean = true>(options: Options<ExportPortfolioSdgRevenueData, ThrowOnError>): RequestResult<ExportPortfolioSdgRevenueResponses, ExportPortfolioSdgRevenueErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<ExportPortfolioSdgRevenueResponses, ExportPortfolioSdgRevenueErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/sdg_revenue/export',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Export Portfolio Dashboard
     *
     * Streamed dashboard portfolio export. Does not send email.
     *
     * The `metric_config_id` field in the body can be:
     * - UUID(int=0): run export with major metrics & KPIs.
     * - UUID(abc): run export with metrics_config <abc>
     */
    public static exportPortfolioDashboard<ThrowOnError extends boolean = true>(options: Options<ExportPortfolioDashboardData, ThrowOnError>): RequestResult<ExportPortfolioDashboardResponses, ExportPortfolioDashboardErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<ExportPortfolioDashboardResponses, ExportPortfolioDashboardErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/dashboard/export',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Export Portfolio Data
     *
     * Streamed portfolio data export. Does not send email.
     */
    public static exportPortfolioData<ThrowOnError extends boolean = true>(options: Options<ExportPortfolioDataData, ThrowOnError>): RequestResult<ExportPortfolioDataResponses, ExportPortfolioDataErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<ExportPortfolioDataResponses, ExportPortfolioDataErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/data/export',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Copy Portfolio View
     */
    public static copyPortfolio<ThrowOnError extends boolean = true>(options: Options<CopyPortfolioData, ThrowOnError>): RequestResult<CopyPortfolioResponses, CopyPortfolioErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CopyPortfolioResponses, CopyPortfolioErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/{portfolio_id}/copy',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Copy Reference Portfolio View
     */
    public static copyReferencePortfolio<ThrowOnError extends boolean = true>(options: Options<CopyReferencePortfolioData, ThrowOnError>): RequestResult<CopyReferencePortfolioResponses, CopyReferencePortfolioErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CopyReferencePortfolioResponses, CopyReferencePortfolioErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/copy-reference',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Dashboard Data
     *
     * Get the impact summary of the portfolio `portfolio_id`.
     *
     * Pass `question_id` (repeatable) to summarise specific questions; it takes
     * priority over `metrics_config_id`.
     */
    public static getPortfolioDashboardData<ThrowOnError extends boolean = true>(options: Options<GetPortfolioDashboardDataData, ThrowOnError>): RequestResult<GetPortfolioDashboardDataResponses, GetPortfolioDashboardDataErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetPortfolioDashboardDataResponses, GetPortfolioDashboardDataErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/{portfolio_id}/dashboard',
            ...options
        });
    }
    
    /**
     * Disclosure Data
     *
     * Get the disclosure data for the portfolio with the given `portfolio_id`.
     */
    public static getDisclosureData<ThrowOnError extends boolean = true>(options: Options<GetDisclosureDataData, ThrowOnError>): RequestResult<GetDisclosureDataResponses, GetDisclosureDataErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetDisclosureDataResponses, GetDisclosureDataErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/{portfolio_id}/disclosure',
            ...options
        });
    }
    
    /**
     * Upload Portfolio
     *
     * Upload a csv or excel file with columns of `Name`, `ISIN` and `Weight`
     * to start an asynchronous process to create a new portfolio.
     *
     *
     * The `result_id` in the returned data can be polled
     * for it's status at `/results?result_token=<result_id>`.
     *
     */
    public static uploadPortfolio<ThrowOnError extends boolean = true>(options: Options<UploadPortfolioData, ThrowOnError>): RequestResult<UploadPortfolioResponses, UploadPortfolioErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<UploadPortfolioResponses, UploadPortfolioErrors, ThrowOnError, 'data'>({
            ...formDataBodySerializer,
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/upload',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Upload Portfolio With Fund Holdings
     *
     * Upload excel file with fund of funds portfolio holdings.
     *
     * 1. Create a data sheet with `Name`, `ISIN` and `Weight` columns
     * and add your direct and fund holdings.
     * You may use an ISIN or a unique code for the ISIN field for funds.
     * This is your fund of funds portfolio.
     * The total weight of your portfolio may be below 100% but not above.
     * For cash holdings, you may remove or include using CCY CASH as the ISIN.
     *
     * 2. For your fund holdings, use a new sheet and rename the sheet with
     * the fund ISIN field used in Step 1.
     * Fill in the sheet with security names, ISINs and weights.
     * These are the holdings within your fund.
     * 3. Add new sheet and repeat step 2 for all the funds in your fund of funds
     * portfolio.
     * Funds can only contain direct holdings.
     *
     * This will start an asynchronous process to create a new portfolio.
     *
     *
     * The `result_id` in the returned data can be polled
     * for it's status at `/results?result_token=<result_id>`.
     *
     */
    public static uploadPortfolioWithFundHoldings<ThrowOnError extends boolean = true>(options: Options<UploadPortfolioWithFundHoldingsData, ThrowOnError>): RequestResult<UploadPortfolioWithFundHoldingsResponses, UploadPortfolioWithFundHoldingsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<UploadPortfolioWithFundHoldingsResponses, UploadPortfolioWithFundHoldingsErrors, ThrowOnError, 'data'>({
            ...formDataBodySerializer,
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/upload_with_funds',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Create Watchlist With Entities
     *
     * Create a portfolio of type watchlist from the provided list of entities.
     *
     * Please note all holdings within a watchlist will have the same weight.
     */
    public static createWatchlist<ThrowOnError extends boolean = true>(options: Options<CreateWatchlistData, ThrowOnError>): RequestResult<CreateWatchlistResponses, CreateWatchlistErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CreateWatchlistResponses, CreateWatchlistErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/watchlist',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Add Entities To Given Watchlist
     *
     * Add given entities to an existing watchlist, unless they are already part of this.
     *
     * Holdings will also be reset, so they all have the same weight.
     */
    public static updatePortfolioHoldings<ThrowOnError extends boolean = true>(options: Options<UpdatePortfolioHoldingsData, ThrowOnError>): RequestResult<UpdatePortfolioHoldingsResponses, UpdatePortfolioHoldingsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdatePortfolioHoldingsResponses, UpdatePortfolioHoldingsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/watchlist/{portfolio_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Holdings From Watchlist
     *
     * Delete given entities/holdings from an existing watchlist.
     *
     * Remaining holdings will also be reset, so they all have the same weight.
     */
    public static deleteHoldingsFromWatchlist<ThrowOnError extends boolean = true>(options: Options<DeleteHoldingsFromWatchlistData, ThrowOnError>): RequestResult<DeleteHoldingsFromWatchlistResponses, DeleteHoldingsFromWatchlistErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).patch<DeleteHoldingsFromWatchlistResponses, DeleteHoldingsFromWatchlistErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/watchlist/{portfolio_id}/delete_holdings',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List All Portfolio Data
     *
     * Lists accepted facts, KPI results and estimated datapoints for a given portfolio.
     *
     *
     * ## Query Parameters:
     * This query can be modified by the following instructions.
     * These need to be compiled as a query parameter string,
     * and passed under the key of `q`
     * ```
     * e.g. ?q=limit%3D2000%26entity_id%3D2699
     * ```
     * Where %3D is a urlencoded `=`
     *
     *
     * ## filtering:
     * To filter the list pass in param values of key=val1[&key=val2...]
     * to indicate the values you wish to filter by
     *
     * ## modifiers:
     * You may prefix the keys with a modifier to change the logical test used in the
     * filter (the default being `=`):
     * * ! - not equal
     * * % - fuzzy - string only - Will search for substring `*val*`
     * * ~ - fuzzy not - string only - Will exclude things matching `*val*`
     *
     * ## sorting:
     * An optional key of `sort_by` may be included in the parameters to indicate the
     * parameters you wish to sort by. Prefixing the column name with a `-`
     * will change from ascending to descending
     *
     * ## page:
     * The key `page` specifies which page of results you wish to return
     *
     * ## limit:
     * The key `limit` specifies how many results you wish per page
     *
     */
    public static listPortfolioData<ThrowOnError extends boolean = true>(options: Options<ListPortfolioDataData, ThrowOnError>): RequestResult<ListPortfolioDataResponses, ListPortfolioDataErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<ListPortfolioDataResponses, ListPortfolioDataErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/{portfolio_id}/all_data',
            ...options
        });
    }
    
    /**
     * Get Portfolio Sdg Outcomes Summary
     */
    public static getPortfolioSdgOutcomesSummary<ThrowOnError extends boolean = true>(options: Options<GetPortfolioSdgOutcomesSummaryData, ThrowOnError>): RequestResult<GetPortfolioSdgOutcomesSummaryResponses, GetPortfolioSdgOutcomesSummaryErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetPortfolioSdgOutcomesSummaryResponses, GetPortfolioSdgOutcomesSummaryErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/{portfolio_id}/sdg_summary/outcomes',
            ...options
        });
    }
    
    /**
     * Get Portfolio Sdg Revenue Summary Weighted
     */
    public static getPortfolioSdgRevenueSummaryWeighted<ThrowOnError extends boolean = true>(options: Options<GetPortfolioSdgRevenueSummaryWeightedData, ThrowOnError>): RequestResult<GetPortfolioSdgRevenueSummaryWeightedResponses, GetPortfolioSdgRevenueSummaryWeightedErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetPortfolioSdgRevenueSummaryWeightedResponses, GetPortfolioSdgRevenueSummaryWeightedErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/{portfolio_id}/sdg_summary/revenue_weighted',
            ...options
        });
    }
    
    /**
     * Get Portfolio Sdg Revenue Summary Unweighted
     */
    public static getPortfolioSdgRevenueSummaryUnweighted<ThrowOnError extends boolean = true>(options: Options<GetPortfolioSdgRevenueSummaryUnweightedData, ThrowOnError>): RequestResult<GetPortfolioSdgRevenueSummaryUnweightedResponses, GetPortfolioSdgRevenueSummaryUnweightedErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetPortfolioSdgRevenueSummaryUnweightedResponses, GetPortfolioSdgRevenueSummaryUnweightedErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/{portfolio_id}/sdg_summary/revenue_unweighted',
            ...options
        });
    }
    
    /**
     * Get Portfolio Sdi Revenue Summary Unweighted
     *
     * Get the unweighted SDI revenue contribution of the portfolio `portfolio_id`.
     */
    public static getPortfolioSdiRevenueSummaryUnweighted<ThrowOnError extends boolean = true>(options: Options<GetPortfolioSdiRevenueSummaryUnweightedData, ThrowOnError>): RequestResult<GetPortfolioSdiRevenueSummaryUnweightedResponses, GetPortfolioSdiRevenueSummaryUnweightedErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetPortfolioSdiRevenueSummaryUnweightedResponses, GetPortfolioSdiRevenueSummaryUnweightedErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/{portfolio_id}/sdi_summary/revenue_unweighted',
            ...options
        });
    }
    
    /**
     * Get Portfolio Sdi Revenue Summary Weighted
     *
     * Get the AUM weighted SDI revenue contribution of the portfolio
     * `portfolio_id`.
     */
    public static getPortfolioSdiRevenueSummaryWeighted<ThrowOnError extends boolean = true>(options: Options<GetPortfolioSdiRevenueSummaryWeightedData, ThrowOnError>): RequestResult<GetPortfolioSdiRevenueSummaryWeightedResponses, GetPortfolioSdiRevenueSummaryWeightedErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetPortfolioSdiRevenueSummaryWeightedResponses, GetPortfolioSdiRevenueSummaryWeightedErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/{portfolio_id}/sdi_summary/revenue_weighted',
            ...options
        });
    }
    
    /**
     * Get Portfolio Sdi Classification Summary Unweighted
     *
     * Get the number of entities in each SDI classification category for the
     * portfolio `portfolio_id`.
     */
    public static getPortfolioLabelsUnweighted<ThrowOnError extends boolean = true>(options: Options<GetPortfolioLabelsUnweightedData, ThrowOnError>): RequestResult<GetPortfolioLabelsUnweightedResponses, GetPortfolioLabelsUnweightedErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetPortfolioLabelsUnweightedResponses, GetPortfolioLabelsUnweightedErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/{portfolio_id}/sdi_summary/classification_unweighted',
            ...options
        });
    }
    
    /**
     * Get Portfolio Sdi Classification Summary Weighted
     *
     * Get the AUM in each SDI classification category for the portfolio
     * `portfolio_id`.
     */
    public static getPortfolioLabelsWeighted<ThrowOnError extends boolean = true>(options: Options<GetPortfolioLabelsWeightedData, ThrowOnError>): RequestResult<GetPortfolioLabelsWeightedResponses, GetPortfolioLabelsWeightedErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetPortfolioLabelsWeightedResponses, GetPortfolioLabelsWeightedErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/{portfolio_id}/sdi_summary/classification_weighted',
            ...options
        });
    }
    
    /**
     * List Portfolio Snapshots
     *
     * Lists all snapshots for a given portfolio.
     *
     *
     * ## Query Parameters:
     * This query can be modified by the following instructions.
     * These need to be compiled as a query parameter string,
     * and passed under the key of `q`
     * ```
     * e.g. ?q=limit%3D2000%26entity_id%3D2699
     * ```
     * Where %3D is a urlencoded `=`
     *
     *
     * ## filtering:
     * To filter the list pass in param values of key=val1[&key=val2...]
     * to indicate the values you wish to filter by
     *
     * ## modifiers:
     * You may prefix the keys with a modifier to change the logical test used in the
     * filter (the default being `=`):
     * * ! - not equal
     * * % - fuzzy - string only - Will search for substring `*val*`
     * * ~ - fuzzy not - string only - Will exclude things matching `*val*`
     *
     * ## sorting:
     * An optional key of `sort_by` may be included in the parameters to indicate the
     * parameters you wish to sort by. Prefixing the column name with a `-`
     * will change from ascending to descending
     *
     * ## page:
     * The key `page` specifies which page of results you wish to return
     *
     * ## limit:
     * The key `limit` specifies how many results you wish per page
     *
     */
    public static listPortfolioSnapshots<ThrowOnError extends boolean = true>(options: Options<ListPortfolioSnapshotsData, ThrowOnError>): RequestResult<ListPortfolioSnapshotsResponses, ListPortfolioSnapshotsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<ListPortfolioSnapshotsResponses, ListPortfolioSnapshotsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/portfolios/{portfolio_id}/snapshots',
            ...options
        });
    }
}

export class QuestionsService {
    /**
     * Get Goal Questions
     */
    public static getGoalQuestions<ThrowOnError extends boolean = true>(options?: Options<GetGoalQuestionsData, ThrowOnError>): RequestResult<GetGoalQuestionsResponses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<GetGoalQuestionsResponses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/questions/goals',
            ...options
        });
    }
    
    /**
     * Get Question Names
     */
    public static getQuestionNames<ThrowOnError extends boolean = true>(options?: Options<GetQuestionNamesData, ThrowOnError>): RequestResult<GetQuestionNamesResponses, GetQuestionNamesErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<GetQuestionNamesResponses, GetQuestionNamesErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/questions/names',
            ...options
        });
    }
    
    /**
     * Get Question
     */
    public static getQuestion<ThrowOnError extends boolean = true>(options: Options<GetQuestionData, ThrowOnError>): RequestResult<GetQuestionResponses, GetQuestionErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetQuestionResponses, GetQuestionErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/questions/{question_id}',
            ...options
        });
    }
}

export class ResultsService {
    /**
     * Lookup Results
     *
     * Checks the status of the asynchronous task identified by `result_token`
     * and returns the `WorkerResult`. `result_token` becomes the `uuid`
     * of that WorkerResult
     */
    public static getResultStatus<ThrowOnError extends boolean = true>(options: Options<GetResultStatusData, ThrowOnError>): RequestResult<GetResultStatusResponses, GetResultStatusErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetResultStatusResponses, GetResultStatusErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/results',
            ...options
        });
    }
    
    /**
     * List Exports
     *
     * Returns a list of recent exports: non-failed exports from the last 4 weeks and
     * failed exports from the last 24 hours.
     */
    public static listExports<ThrowOnError extends boolean = true>(options?: Options<ListExportsData, ThrowOnError>): RequestResult<ListExportsResponses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListExportsResponses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/results/export_history',
            ...options
        });
    }
}

export class RevenueService {
    /**
     * Get Entity Sdi Revenue Contribution
     *
     * Get the SDI revenue contribution of the entity `entity_id`, split into
     * alignment buckets with the activities behind them.
     */
    public static getEntitySdiRevenueContribution<ThrowOnError extends boolean = true>(options: Options<GetEntitySdiRevenueContributionData, ThrowOnError>): RequestResult<GetEntitySdiRevenueContributionResponses, GetEntitySdiRevenueContributionErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetEntitySdiRevenueContributionResponses, GetEntitySdiRevenueContributionErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/revenue/sdi/entity/{entity_id}',
            ...options
        });
    }
    
    /**
     * Get Entity Sdi Activity Explanation
     *
     * Get the evidence behind one activity of the entity `entity_id`: the
     * segments and supporting facts its revenue was reported in, or the formula
     * results it was derived from. The activity is addressed by the
     * `entity_sdi_revenue_id` its summary row carries, since one taxon can hold
     * several alignments of the same revenue.
     */
    public static getEntitySdiActivityExplanation<ThrowOnError extends boolean = true>(options: Options<GetEntitySdiActivityExplanationData, ThrowOnError>): RequestResult<GetEntitySdiActivityExplanationResponses, GetEntitySdiActivityExplanationErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetEntitySdiActivityExplanationResponses, GetEntitySdiActivityExplanationErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/revenue/sdi/entity/{entity_id}/activities/{entity_sdi_revenue_id}',
            ...options
        });
    }
    
    /**
     * Get Sdi Data Bundle Download Url
     *
     * Get a time limited download url for the current SDI data release.
     */
    public static getSdiDataBundleDownloadUrl<ThrowOnError extends boolean = true>(options?: Options<GetSdiDataBundleDownloadUrlData, ThrowOnError>): RequestResult<GetSdiDataBundleDownloadUrlResponses, GetSdiDataBundleDownloadUrlErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<GetSdiDataBundleDownloadUrlResponses, GetSdiDataBundleDownloadUrlErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/revenue/sdi/data_bundle',
            ...options
        });
    }
    
    /**
     * Get Sdi Subscriber Pack Download Url
     *
     * Get a time limited download url for the current SDI subscriber pack.
     */
    public static getSdiSubscriberPackDownloadUrl<ThrowOnError extends boolean = true>(options?: Options<GetSdiSubscriberPackDownloadUrlData, ThrowOnError>): RequestResult<GetSdiSubscriberPackDownloadUrlResponses, GetSdiSubscriberPackDownloadUrlErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<GetSdiSubscriberPackDownloadUrlResponses, GetSdiSubscriberPackDownloadUrlErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/revenue/sdi/subscriber_pack',
            ...options
        });
    }
    
    /**
     * Export Entity Sdi Revenue
     *
     * Download the SDI revenue contribution of the entity `entity_id` as a
     * minimally formatted excel: one row per activity, plus a total.
     */
    public static exportEntitySdiRevenueXlsx<ThrowOnError extends boolean = true>(options: Options<ExportEntitySdiRevenueXlsxData, ThrowOnError>): RequestResult<ExportEntitySdiRevenueXlsxResponses, ExportEntitySdiRevenueXlsxErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<ExportEntitySdiRevenueXlsxResponses, ExportEntitySdiRevenueXlsxErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/revenue/sdi/entity/{entity_id}/export',
            ...options
        });
    }
    
    /**
     * Export All Sdi Files
     *
     * Download all the SDI files for the given branch.
     */
    public static exportAllSdiFilesXlsx<ThrowOnError extends boolean = true>(options: Options<ExportAllSdiFilesXlsxData, ThrowOnError>): RequestResult<ExportAllSdiFilesXlsxResponses, ExportAllSdiFilesXlsxErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<ExportAllSdiFilesXlsxResponses, ExportAllSdiFilesXlsxErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/revenue/sdi/export',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Trigger Sdi Revenue Pipeline
     *
     * Trigger the promoted revenue pipeline on the preview branch so the current
     * SDI exports can be regenerated. The branch is hardcoded to preview to avoid
     * accidentally running the main promotion.
     */
    public static triggerSdiRevenuePipeline<ThrowOnError extends boolean = true>(options: Options<TriggerSdiRevenuePipelineData, ThrowOnError>): RequestResult<TriggerSdiRevenuePipelineResponses, TriggerSdiRevenuePipelineErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<TriggerSdiRevenuePipelineResponses, TriggerSdiRevenuePipelineErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/revenue/sdi/trigger_revenue_pipeline',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SearchService {
    /**
     * Global Search
     *
     *
     * ## Query Parameters:
     * This query can be modified by the following instructions.
     * These need to be compiled as a query parameter string,
     * and passed under the key of `q`
     * ```
     * e.g. ?q=limit%3D2000%26entity_id%3D2699
     * ```
     * Where %3D is a urlencoded `=`
     *
     *
     * ## filtering:
     * To filter the list pass in param values of key=val1[&key=val2...]
     * to indicate the values you wish to filter by
     *
     * ## modifiers:
     * You may prefix the keys with a modifier to change the logical test used in the
     * filter (the default being `=`):
     * * ! - not equal
     * * % - fuzzy - string only - Will search for substring `*val*`
     * * ~ - fuzzy not - string only - Will exclude things matching `*val*`
     *
     * ## sorting:
     * An optional key of `sort_by` may be included in the parameters to indicate the
     * parameters you wish to sort by. Prefixing the column name with a `-`
     * will change from ascending to descending
     *
     * ## page:
     * The key `page` specifies which page of results you wish to return
     *
     * ## limit:
     * The key `limit` specifies how many results you wish per page
     *
     */
    public static globalSearch<ThrowOnError extends boolean = true>(options?: Options<GlobalSearchData, ThrowOnError>): RequestResult<GlobalSearchResponses, GlobalSearchErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<GlobalSearchResponses, GlobalSearchErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/search',
            ...options
        });
    }
}

export class SegmentsService {
    /**
     * List Segments
     *
     * List all segments in the the system.
     * Segments are more granular divisions of results. e.g. geographical information.
     *
     *
     * ## Query Parameters:
     * This query can be modified by the following instructions.
     * These need to be compiled as a query parameter string,
     * and passed under the key of `q`
     * ```
     * e.g. ?q=limit%3D2000%26entity_id%3D2699
     * ```
     * Where %3D is a urlencoded `=`
     *
     *
     * ## filtering:
     * To filter the list pass in param values of key=val1[&key=val2...]
     * to indicate the values you wish to filter by
     *
     * ## modifiers:
     * You may prefix the keys with a modifier to change the logical test used in the
     * filter (the default being `=`):
     * * ! - not equal
     * * % - fuzzy - string only - Will search for substring `*val*`
     * * ~ - fuzzy not - string only - Will exclude things matching `*val*`
     *
     * ## sorting:
     * An optional key of `sort_by` may be included in the parameters to indicate the
     * parameters you wish to sort by. Prefixing the column name with a `-`
     * will change from ascending to descending
     *
     * ## page:
     * The key `page` specifies which page of results you wish to return
     *
     * ## limit:
     * The key `limit` specifies how many results you wish per page
     *
     */
    public static listSegments<ThrowOnError extends boolean = true>(options?: Options<ListSegmentsData, ThrowOnError>): RequestResult<ListSegmentsResponses, ListSegmentsErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListSegmentsResponses, ListSegmentsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/segments',
            ...options
        });
    }
    
    /**
     * Create Segment
     */
    public static createSegment<ThrowOnError extends boolean = true>(options: Options<CreateSegmentData, ThrowOnError>): RequestResult<CreateSegmentResponses, CreateSegmentErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CreateSegmentResponses, CreateSegmentErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/segments',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Eu Sfdr Segments
     *
     * List all EuSfdrTaxonomy Segments in the system.
     *
     *
     * ## Query Parameters:
     * This query can be modified by the following instructions.
     * These need to be compiled as a query parameter string,
     * and passed under the key of `q`
     * ```
     * e.g. ?q=limit%3D2000%26entity_id%3D2699
     * ```
     * Where %3D is a urlencoded `=`
     *
     *
     * ## filtering:
     * To filter the list pass in param values of key=val1[&key=val2...]
     * to indicate the values you wish to filter by
     *
     * ## modifiers:
     * You may prefix the keys with a modifier to change the logical test used in the
     * filter (the default being `=`):
     * * ! - not equal
     * * % - fuzzy - string only - Will search for substring `*val*`
     * * ~ - fuzzy not - string only - Will exclude things matching `*val*`
     *
     * ## sorting:
     * An optional key of `sort_by` may be included in the parameters to indicate the
     * parameters you wish to sort by. Prefixing the column name with a `-`
     * will change from ascending to descending
     *
     * ## page:
     * The key `page` specifies which page of results you wish to return
     *
     * ## limit:
     * The key `limit` specifies how many results you wish per page
     *
     */
    public static listEuSfdrSegments<ThrowOnError extends boolean = true>(options?: Options<ListEuSfdrSegmentsData, ThrowOnError>): RequestResult<ListEuSfdrSegmentsResponses, ListEuSfdrSegmentsErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListEuSfdrSegmentsResponses, ListEuSfdrSegmentsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/segments/eu_sfdr',
            ...options
        });
    }
    
    /**
     * Delete Segment
     */
    public static deleteSegment<ThrowOnError extends boolean = true>(options: Options<DeleteSegmentData, ThrowOnError>): RequestResult<DeleteSegmentResponses, DeleteSegmentErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DeleteSegmentResponses, DeleteSegmentErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/segments/{segment_id}',
            ...options
        });
    }
    
    /**
     * Get Segment
     *
     * Get the segment identified by `segment_id`
     */
    public static getSegment<ThrowOnError extends boolean = true>(options: Options<GetSegmentData, ThrowOnError>): RequestResult<GetSegmentResponses, GetSegmentErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetSegmentResponses, GetSegmentErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/segments/{segment_id}',
            ...options
        });
    }
    
    /**
     * Update Segment
     */
    public static updateSegment<ThrowOnError extends boolean = true>(options: Options<UpdateSegmentData, ThrowOnError>): RequestResult<UpdateSegmentResponses, UpdateSegmentErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateSegmentResponses, UpdateSegmentErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/segments/{segment_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SemanticSearchService {
    /**
     * Search
     */
    public static listFeedback<ThrowOnError extends boolean = true>(options: Options<ListFeedbackData, ThrowOnError>): RequestResult<ListFeedbackResponses, ListFeedbackErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<ListFeedbackResponses, ListFeedbackErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/semantic_search/feedback',
            ...options
        });
    }
    
    /**
     * Send Feedback
     */
    public static sendFeedback<ThrowOnError extends boolean = true>(options: Options<SendFeedbackData, ThrowOnError>): RequestResult<SendFeedbackResponses, SendFeedbackErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<SendFeedbackResponses, SendFeedbackErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/semantic_search/feedback',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Update Feedback
     */
    public static updateFeedback<ThrowOnError extends boolean = true>(options: Options<UpdateFeedbackData, ThrowOnError>): RequestResult<UpdateFeedbackResponses, UpdateFeedbackErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateFeedbackResponses, UpdateFeedbackErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/semantic_search/feedback/{feedback_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SourcesService {
    /**
     * List Sources
     *
     * Returns all sources on file.
     *
     * prediction_labels: list[str] = None (default to all labels)
     */
    public static listSources<ThrowOnError extends boolean = true>(options?: Options<ListSourcesData, ThrowOnError>): RequestResult<ListSourcesResponses, ListSourcesErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListSourcesResponses, ListSourcesErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/sources',
            ...options
        });
    }
    
    /**
     * Create Source
     */
    public static createSource<ThrowOnError extends boolean = true>(options: Options<CreateSourceData, ThrowOnError>): RequestResult<CreateSourceResponses, CreateSourceErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CreateSourceResponses, CreateSourceErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/sources',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Upload From Url
     */
    public static uploadSourceFromUrl<ThrowOnError extends boolean = true>(options: Options<UploadSourceFromUrlData, ThrowOnError>): RequestResult<UploadSourceFromUrlResponses, UploadSourceFromUrlErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<UploadSourceFromUrlResponses, UploadSourceFromUrlErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/sources/upload',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Upload From File
     */
    public static uploadSourceFromFile<ThrowOnError extends boolean = true>(options: Options<UploadSourceFromFileData, ThrowOnError>): RequestResult<UploadSourceFromFileResponses, UploadSourceFromFileErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<UploadSourceFromFileResponses, UploadSourceFromFileErrors, ThrowOnError, 'data'>({
            ...formDataBodySerializer,
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/sources/upload-file',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Source
     */
    public static deleteSource<ThrowOnError extends boolean = true>(options: Options<DeleteSourceData, ThrowOnError>): RequestResult<DeleteSourceResponses, DeleteSourceErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DeleteSourceResponses, DeleteSourceErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/sources/{source_id}',
            ...options
        });
    }
    
    /**
     * Get Source
     *
     * Get the source identified by `source_id`
     */
    public static getSource<ThrowOnError extends boolean = true>(options: Options<GetSourceData, ThrowOnError>): RequestResult<GetSourceResponses, GetSourceErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetSourceResponses, GetSourceErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/sources/{source_id}',
            ...options
        });
    }
    
    /**
     * Dissociate Source From Entity
     */
    public static dissociateSourceFromEntity<ThrowOnError extends boolean = true>(options: Options<DissociateSourceFromEntityData, ThrowOnError>): RequestResult<DissociateSourceFromEntityResponses, DissociateSourceFromEntityErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).patch<DissociateSourceFromEntityResponses, DissociateSourceFromEntityErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/sources/{source_id}',
            ...options
        });
    }
    
    /**
     * Update Source
     */
    public static updateSource<ThrowOnError extends boolean = true>(options: Options<UpdateSourceData, ThrowOnError>): RequestResult<UpdateSourceResponses, UpdateSourceErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateSourceResponses, UpdateSourceErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/sources/{source_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Embed Source
     */
    public static embedSources<ThrowOnError extends boolean = true>(options: Options<EmbedSourcesData, ThrowOnError>): RequestResult<EmbedSourcesResponses, EmbedSourcesErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<EmbedSourcesResponses, EmbedSourcesErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/sources/embed',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Write Up
     *
     * Get the write up for a given entity
     */
    public static getWriteUp<ThrowOnError extends boolean = true>(options: Options<GetWriteUpData, ThrowOnError>): RequestResult<GetWriteUpResponses, GetWriteUpErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetWriteUpResponses, GetWriteUpErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/sources/write-up/{entity_id}',
            ...options
        });
    }
    
    /**
     * Merge Sources
     */
    public static mergeSources<ThrowOnError extends boolean = true>(options: Options<MergeSourcesData, ThrowOnError>): RequestResult<MergeSourcesResponses, MergeSourcesErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<MergeSourcesResponses, MergeSourcesErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/sources/merge',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Page Predictions
     */
    public static getPagePredictions<ThrowOnError extends boolean = true>(options: Options<GetPagePredictionsData, ThrowOnError>): RequestResult<GetPagePredictionsResponses, GetPagePredictionsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetPagePredictionsResponses, GetPagePredictionsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/sources/{source_id}/page_predictions',
            ...options
        });
    }
    
    /**
     * Get Theme Page Predictions
     */
    public static getThemePagePredictions<ThrowOnError extends boolean = true>(options: Options<GetThemePagePredictionsData, ThrowOnError>): RequestResult<GetThemePagePredictionsResponses, GetThemePagePredictionsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetThemePagePredictionsResponses, GetThemePagePredictionsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/sources/{source_id}/theme_page_predictions',
            ...options
        });
    }
    
    /**
     * Get Metric Page Predictions
     */
    public static getMetricPagePredictions<ThrowOnError extends boolean = true>(options: Options<GetMetricPagePredictionsData, ThrowOnError>): RequestResult<GetMetricPagePredictionsResponses, GetMetricPagePredictionsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetMetricPagePredictionsResponses, GetMetricPagePredictionsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/sources/{source_id}/metric_page_predictions',
            ...options
        });
    }
    
    /**
     * Get Report Types Confidence
     */
    public static getReportTypesConfidence<ThrowOnError extends boolean = true>(options: Options<GetReportTypesConfidenceData, ThrowOnError>): RequestResult<GetReportTypesConfidenceResponses, GetReportTypesConfidenceErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetReportTypesConfidenceResponses, GetReportTypesConfidenceErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/sources/report_types_confidence/{metric_id}',
            ...options
        });
    }
}

export class SnapshotsService {
    /**
     * Delete Snapshot
     *
     * Delete the snapshot and all associated holdings identified by `snapshot_id`
     */
    public static deleteSnapshot<ThrowOnError extends boolean = true>(options: Options<DeleteSnapshotData, ThrowOnError>): RequestResult<DeleteSnapshotResponses, DeleteSnapshotErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DeleteSnapshotResponses, DeleteSnapshotErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/snapshots/{snapshot_id}',
            ...options
        });
    }
    
    /**
     * Get Snapshot With Holdings
     *
     * Get snapshot of portfolio identified by `snapshot_id`.
     * Includes information on the coverage of
     * the entities linked by the holdings.
     */
    public static getSnapshotWithHoldings<ThrowOnError extends boolean = true>(options: Options<GetSnapshotWithHoldingsData, ThrowOnError>): RequestResult<GetSnapshotWithHoldingsResponses, GetSnapshotWithHoldingsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetSnapshotWithHoldingsResponses, GetSnapshotWithHoldingsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/snapshots/{snapshot_id}',
            ...options
        });
    }
    
    /**
     * Get Snapshot With Num Holdings
     *
     * Get snapshot of portfolio identified by `snapshot_id`.
     * Includes number of holdings the snapshot has.
     */
    public static getSnapshotWithNumHoldings<ThrowOnError extends boolean = true>(options: Options<GetSnapshotWithNumHoldingsData, ThrowOnError>): RequestResult<GetSnapshotWithNumHoldingsResponses, GetSnapshotWithNumHoldingsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetSnapshotWithNumHoldingsResponses, GetSnapshotWithNumHoldingsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/snapshots/{snapshot_id}/num_holdings',
            ...options
        });
    }
}

export class ReportingStandardsService {
    /**
     * Get Reporting Standards
     *
     * Returns the list of reporting standards.
     */
    public static getReportingStandards<ThrowOnError extends boolean = true>(options?: Options<GetReportingStandardsData, ThrowOnError>): RequestResult<GetReportingStandardsResponses, GetReportingStandardsErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<GetReportingStandardsResponses, GetReportingStandardsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/standards',
            ...options
        });
    }
}

export class StatsService {
    /**
     * Coverage Stats
     */
    public static getCoverageStats<ThrowOnError extends boolean = true>(options?: Options<GetCoverageStatsData, ThrowOnError>): RequestResult<GetCoverageStatsResponses, GetCoverageStatsErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<GetCoverageStatsResponses, GetCoverageStatsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/stats/coverage',
            ...options
        });
    }
    
    /**
     * Analyst Stats
     */
    public static getAnalystStats<ThrowOnError extends boolean = true>(options: Options<GetAnalystStatsData, ThrowOnError>): RequestResult<GetAnalystStatsResponses, GetAnalystStatsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetAnalystStatsResponses, GetAnalystStatsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/stats/analysis/{worker_id}',
            ...options
        });
    }
    
    /**
     * Overall Stats
     */
    public static getOverallStats<ThrowOnError extends boolean = true>(options: Options<GetOverallStatsData, ThrowOnError>): RequestResult<GetOverallStatsResponses, GetOverallStatsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetOverallStatsResponses, GetOverallStatsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/stats/analysis',
            ...options
        });
    }
}

export class TasksService {
    /**
     * Get Next Task Across Steps View
     */
    public static getNextTaskAcrossSteps<ThrowOnError extends boolean = true>(options?: Options<GetNextTaskAcrossStepsData, ThrowOnError>): RequestResult<GetNextTaskAcrossStepsResponses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<GetNextTaskAcrossStepsResponses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tasks/next',
            ...options
        });
    }
    
    /**
     * Get Next Task View
     */
    public static getNextTask<ThrowOnError extends boolean = true>(options: Options<GetNextTaskData, ThrowOnError>): RequestResult<GetNextTaskResponses, GetNextTaskErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetNextTaskResponses, GetNextTaskErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tasks/next/{step}',
            ...options
        });
    }
    
    /**
     * Ingestion Get Task
     */
    public static getIngestionTask<ThrowOnError extends boolean = true>(options: Options<GetIngestionTaskData, ThrowOnError>): RequestResult<GetIngestionTaskResponses, GetIngestionTaskErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetIngestionTaskResponses, GetIngestionTaskErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tasks/ingestion/{task_id}',
            ...options
        });
    }
    
    /**
     * Ingestion Submit Task
     */
    public static submitIngestionTask<ThrowOnError extends boolean = true>(options: Options<SubmitIngestionTaskData, ThrowOnError>): RequestResult<SubmitIngestionTaskResponses, SubmitIngestionTaskErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<SubmitIngestionTaskResponses, SubmitIngestionTaskErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tasks/ingestion/{task_id}/submit',
            ...options
        });
    }
    
    /**
     * Ingestion Abandon Task
     */
    public static abandonIngestionTask<ThrowOnError extends boolean = true>(options: Options<AbandonIngestionTaskData, ThrowOnError>): RequestResult<AbandonIngestionTaskResponses, AbandonIngestionTaskErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<AbandonIngestionTaskResponses, AbandonIngestionTaskErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tasks/ingestion/{task_id}/abandon',
            ...options
        });
    }
    
    /**
     * Assign Ingestion Task
     */
    public static assignIngestionTask<ThrowOnError extends boolean = true>(options: Options<AssignIngestionTaskData, ThrowOnError>): RequestResult<AssignIngestionTaskResponses, AssignIngestionTaskErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<AssignIngestionTaskResponses, AssignIngestionTaskErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tasks/ingestion/{task_id}/assign/{user_id}',
            ...options
        });
    }
    
    /**
     * Ingestion Update Elapsed
     */
    public static updateIngestionTaskElapsedTime<ThrowOnError extends boolean = true>(options: Options<UpdateIngestionTaskElapsedTimeData, ThrowOnError>): RequestResult<UpdateIngestionTaskElapsedTimeResponses, UpdateIngestionTaskElapsedTimeErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateIngestionTaskElapsedTimeResponses, UpdateIngestionTaskElapsedTimeErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tasks/ingestion/{task_id}/update_elapsed/{elapsed}',
            ...options
        });
    }
    
    /**
     * Ingestion Send For Autoqa
     */
    public static sendIngestionTaskForAutoqa<ThrowOnError extends boolean = true>(options: Options<SendIngestionTaskForAutoqaData, ThrowOnError>): RequestResult<SendIngestionTaskForAutoqaResponses, SendIngestionTaskForAutoqaErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<SendIngestionTaskForAutoqaResponses, SendIngestionTaskForAutoqaErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tasks/ingestion/{task_id}/autoqa',
            ...options
        });
    }
    
    /**
     * Ingestion Return To Queue
     *
     * Return from the CANNOT_PROGRESS state to the queue; this should just set to
     * IN_PROGRESS and unassign the user.
     */
    public static returnIngestionTaskToQueue<ThrowOnError extends boolean = true>(options: Options<ReturnIngestionTaskToQueueData, ThrowOnError>): RequestResult<ReturnIngestionTaskToQueueResponses, ReturnIngestionTaskToQueueErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<ReturnIngestionTaskToQueueResponses, ReturnIngestionTaskToQueueErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tasks/ingestion/{task_id}/return_to_queue',
            ...options
        });
    }
    
    /**
     * Source Get Task
     */
    public static getSourceTask<ThrowOnError extends boolean = true>(options: Options<GetSourceTaskData, ThrowOnError>): RequestResult<GetSourceTaskResponses, GetSourceTaskErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetSourceTaskResponses, GetSourceTaskErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tasks/source/{task_id}',
            ...options
        });
    }
    
    /**
     * Source Submit Task
     */
    public static submitSourceTask<ThrowOnError extends boolean = true>(options: Options<SubmitSourceTaskData, ThrowOnError>): RequestResult<SubmitSourceTaskResponses, SubmitSourceTaskErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<SubmitSourceTaskResponses, SubmitSourceTaskErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tasks/source/{task_id}/submit',
            ...options
        });
    }
    
    /**
     * Source Abandon Task
     */
    public static abandonSourceTask<ThrowOnError extends boolean = true>(options: Options<AbandonSourceTaskData, ThrowOnError>): RequestResult<AbandonSourceTaskResponses, AbandonSourceTaskErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<AbandonSourceTaskResponses, AbandonSourceTaskErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tasks/source/{task_id}/abandon',
            ...options
        });
    }
    
    /**
     * Source Update Elapsed
     */
    public static updateSourceTaskElapsedTime<ThrowOnError extends boolean = true>(options: Options<UpdateSourceTaskElapsedTimeData, ThrowOnError>): RequestResult<UpdateSourceTaskElapsedTimeResponses, UpdateSourceTaskElapsedTimeErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateSourceTaskElapsedTimeResponses, UpdateSourceTaskElapsedTimeErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tasks/source/{task_id}/update_elapsed/{elapsed}',
            ...options
        });
    }
    
    /**
     * Create Ingestion Tasks
     *
     * Upload a CSV file of ingestion tasks to create. This sends a request to the np
     * worker, returning the result token of the job.
     */
    public static createIngestionTasks<ThrowOnError extends boolean = true>(options: Options<CreateIngestionTasksData, ThrowOnError>): RequestResult<CreateIngestionTasksResponses, CreateIngestionTasksErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CreateIngestionTasksResponses, CreateIngestionTasksErrors, ThrowOnError, 'data'>({
            ...formDataBodySerializer,
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tasks/ingestion/create_tasks',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Create Source Tasks
     *
     * Upload a CSV file of source tasks to create. This sends a request to the np worker,
     * returning the result token of the job.
     */
    public static createSourceTasks<ThrowOnError extends boolean = true>(options: Options<CreateSourceTasksData, ThrowOnError>): RequestResult<CreateSourceTasksResponses, CreateSourceTasksErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CreateSourceTasksResponses, CreateSourceTasksErrors, ThrowOnError, 'data'>({
            ...formDataBodySerializer,
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tasks/source/create_tasks',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
}

export class UnitsService {
    /**
     * List Units
     *
     * Lists all units in the system and their associated metadata.
     *
     *
     * ## Query Parameters:
     * This query can be modified by the following instructions.
     * These need to be compiled as a query parameter string,
     * and passed under the key of `q`
     * ```
     * e.g. ?q=limit%3D2000%26entity_id%3D2699
     * ```
     * Where %3D is a urlencoded `=`
     *
     *
     * ## filtering:
     * To filter the list pass in param values of key=val1[&key=val2...]
     * to indicate the values you wish to filter by
     *
     * ## modifiers:
     * You may prefix the keys with a modifier to change the logical test used in the
     * filter (the default being `=`):
     * * ! - not equal
     * * % - fuzzy - string only - Will search for substring `*val*`
     * * ~ - fuzzy not - string only - Will exclude things matching `*val*`
     *
     * ## sorting:
     * An optional key of `sort_by` may be included in the parameters to indicate the
     * parameters you wish to sort by. Prefixing the column name with a `-`
     * will change from ascending to descending
     *
     * ## page:
     * The key `page` specifies which page of results you wish to return
     *
     * ## limit:
     * The key `limit` specifies how many results you wish per page
     *
     */
    public static listUnits<ThrowOnError extends boolean = true>(options?: Options<ListUnitsData, ThrowOnError>): RequestResult<ListUnitsResponses, ListUnitsErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListUnitsResponses, ListUnitsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/units',
            ...options
        });
    }
    
    /**
     * Create Unit
     */
    public static createUnit<ThrowOnError extends boolean = true>(options: Options<CreateUnitData, ThrowOnError>): RequestResult<CreateUnitResponses, CreateUnitErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CreateUnitResponses, CreateUnitErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/units',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Convert Unit
     *
     * Convert between units. If no out_unit_id is provided, convert to standard form.
     */
    public static convertUnit<ThrowOnError extends boolean = true>(options: Options<ConvertUnitData, ThrowOnError>): RequestResult<ConvertUnitResponses, ConvertUnitErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<ConvertUnitResponses, ConvertUnitErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/units/convert_unit',
            ...options
        });
    }
    
    /**
     * Delete Unit
     */
    public static deleteUnit<ThrowOnError extends boolean = true>(options: Options<DeleteUnitData, ThrowOnError>): RequestResult<DeleteUnitResponses, DeleteUnitErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DeleteUnitResponses, DeleteUnitErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/units/{instance_id}',
            ...options
        });
    }
    
    /**
     * Get Unit
     */
    public static getUnit<ThrowOnError extends boolean = true>(options: Options<GetUnitData, ThrowOnError>): RequestResult<GetUnitResponses, GetUnitErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetUnitResponses, GetUnitErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/units/{instance_id}',
            ...options
        });
    }
    
    /**
     * Update Unit
     */
    public static updateUnit<ThrowOnError extends boolean = true>(options: Options<UpdateUnitData, ThrowOnError>): RequestResult<UpdateUnitResponses, UpdateUnitErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateUnitResponses, UpdateUnitErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/units/{instance_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Merge Units
     */
    public static mergeUnits<ThrowOnError extends boolean = true>(options: Options<MergeUnitsData, ThrowOnError>): RequestResult<MergeUnitsResponses, MergeUnitsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<MergeUnitsResponses, MergeUnitsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/units/merge',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class DefaultService {
    /**
     * Health Check
     */
    public static healthCheckHealthyGet<ThrowOnError extends boolean = true>(options?: Options<HealthCheckHealthyGetData, ThrowOnError>): RequestResult<HealthCheckHealthyGetResponses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<HealthCheckHealthyGetResponses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            url: '/healthy',
            ...options
        });
    }
    
    /**
     * Deliberate Error
     */
    public static deliberateErrorKaboomGet<ThrowOnError extends boolean = true>(options?: Options<DeliberateErrorKaboomGetData, ThrowOnError>): RequestResult<DeliberateErrorKaboomGetResponses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<DeliberateErrorKaboomGetResponses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            url: '/kaboom',
            ...options
        });
    }
}
